import { ElementRef, Injectable } from "@angular/core";
import { APIService } from "./api.service";
import { Constants } from "../constants";
import { G3msService } from 'src/app/shared/services/g3ms_services/g3ms.service';
import { CookieService } from "ngx-cookie-service";
import { LocalDataService } from "./local-data.service";
import { Router } from "@angular/router";
import { CommonService } from "./common.service";
import { AuthenticationService } from 'src/app/shared/services/auth/authentication.service';
import { PushNotificationService } from "./push-notification.service";
declare var window: any;
import { Client } from "twilio-sync";
import { MatDialog, MatDialogConfig,MatDialogRef} from "@angular/material/dialog";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { IncomingCallComponent } from "src/app/components/elevator-call/incoming-call/incoming-call.component";
import { ElevatorCallService } from "./elevator-call.service";
import * as DOMPurify from "dompurify";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Device,Call } from "@twilio/voice-sdk"
import * as TaskRouter from "twilio-taskrouter";
import { NotificationService } from "./notification.service";
import { environment } from "src/app/environments/environment";
import { AppConfigService } from "./app-config/app-config.service";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
//import { ConfirmLogoutComponent } from "src/app/components/sidebar/confirm-logout/confirm-logout.component";


@Injectable({
    providedIn: 'root'
})
export class TwilioHelperService {
    //private device: Device | undefined;
    device: any;
    call: any;
    elevatorControls: any = {
        speakerVolume: "0",
        micGain: "0",
        prevSpeakerVolume: "0",
        prevMicGain: "0",
        options: {
            floor: 0,
            ceil: 100,
            step: 10,
            vertical: true,
            showSelectionBar: true
        },
        deviceType: '3'
    };
    phoneConnection: any;    
    manualConnection: any;
    callConnected = false;
    isAutoDialer = 0;
    isModelId = 0;
    AgentHanged = false    
    callStatusModal = new BehaviorSubject<any>({});
    callNotifiModal = new BehaviorSubject<any>({});
    //2. Create the data which we want to share with all the components
    callDetails = new BehaviorSubject<any>({}) || undefined;
    //3. Now we want to broadcast this message or data, so we create an observable
    callDetails$ = this.callDetails.asObservable();
    callSettings = new BehaviorSubject<any>({ isAudioMute: false, isVideoMute: false, elevatorControls: this.elevatorControls });
    callInfo = new BehaviorSubject<any>({});    
    worker: any = {};
    agent: any = {
        selectedStatus: undefined,
        prevSelStatus: undefined,
        onCallbackStatus: undefined
    };
    Reservationerror=false;
    AgentCancelled: any;
    agentStatusEmit = new BehaviorSubject<any>(this.agent);
    callNotificationModal = new BehaviorSubject(false);
    identity: any;
    interval = null;
    syncClient: any;
    toggle: boolean = false;
    noAgentOnline: any;
    cancelUserTimeout: any;
    isTimeout: boolean = false;
    loginTime: any;
    noElevatorVideo: boolean = false;
    shutdownReasonArry: any;
    ////video: any = this.getVideoStats();
    temp: any = Constants.ROOM_AUDIO_VIDEO_CONSTANTS;
    isWindowActive = true;
    callTypes: any = Constants.USER_CALLTYPES;
    callStartedDateTime: any = null;    
    workerSid: any;
    callDetailsId: number = 0;
    pingServerCancelTimeout: any;
    syncTimerCount: any = 0;    
    queueCountry: string = '';
    userStatus: any = Constants.USER_CURRENT_STATUS;    
    failureReasonCode: any;
    currentTask: any;    
    userStatusDisplay!: boolean;
    admin!: boolean;
    validateToken: any;
    keepAliveInterval: any;
    loggedOut = true;
    logoutConfrmModel = { display: Constants.APP_CONSTANTS.none };
    main: any = { selectedItem: 0, showMap: false, updateMessage: "" };
    ccAppSid: any;
    roomName: any;
    callTransferer: any;
    targetWorker: any;
    callHanged: boolean = true;
    callOver: boolean = true;
    remoteParticipantSid: any;    
    callCurrentStatus: number = 0;
    currentReservation: any = {};
    callStartedSecs: number = 0;
    commonData: any = { isInCallTimeout: false }
    isInCallTimeout: boolean = false;
    elevatorId: any;    
    activeRoom: any;
    audioTrackAdded: boolean = false;    
    dataTrackAdded: boolean = true;    
    elevatorCarId: any;
    messageDetailsList: any;    
    public ringtone!: ElementRef;
    callInitiator: any = Constants.APP_CONFIG.callInitiator;
    elevator: any = {};
    uuid: any;
    ////elevatorChat: any;
    home: any = { currentPage: 0, isChatCollapse: false, isCollapse: false, micGain: false, volumeChange: false, firstSpeaker: false, firstMic: false, selected: 0 };
    changeStatusConfrmModel: any;
    notifiTimeLeft: number = 0;
    agentVideoTransmitEnable: boolean = false;
    callTimings: number = 0;
    ////isOnlyAudioForCPUUtilization: boolean = false;
    localControls: any;
    taskSid: any;
    voiceCallType: number = 0;    
    activityUpdated: boolean = false;    
    user: any;    
    taskAttributes: any;
    isRoomNotDisconnected: boolean = false;
    incidentDetailsList: any;
    ////dataLoadingG3MS: boolean = false;
    ////isVVAppCall: boolean = false;
    deviceType: any;
    callBackInline: boolean = false;
    callBackElevatorIdField: any = {};
    ////exitConfirmModel: any;
    isCallBackInitiated: boolean = false;
    dispValidated: boolean = false;
    dispositionError: string = '';
    chooseQualityError: string = '';
    notesError: string = '';
    questionText: any;
    callItem4Edit: any;
    callDispstnArry: any;
    ////framRateInterval: any;    
    deviceCheckCalled: any;
    noCameraAvailable: any;
    isCallDisconnected : any = false;
    roomSid: any;
    participantSid: any;
    agentStatusCountData: any;
    agentStatusCount = new Subject();    
    incomingCallStatus = new Subject();
    agentDetails: any;
    homecontroller: any = { g3msResult: { contractInfo: {}, callDetails: {} } };
    workerCallHistory = [];
    mediaErrors = [
        'NotAllowedError',
        'NotFoundError',
        'NotReadableError',
        'OverconstrainedError',
        'TypeError'
    ];
    //find out the call disposition Id & is it been able to change
    callDispoDetails : any = {
        callDispositionId: "0",
        videoQuality: 0,
        audioQuality: 0,
        notes: ""
    };
    displayElevatorId: string = "";
    workerToken = null;
    controls: any = {};
    silenceText: string = '';
    silenceImgPath: string = '';
    elevatorSettings: any = { videEnabled: false };
    connection: any = {};
    tpr: any = {
        status: 'loading ...',
        displayStatus: true,
        labelStatus: true
    };    
    ////callStats = new BehaviorSubject<any>(this.getVideoStats());
    activityChanges = new BehaviorSubject<any>({});
    //join room attributes    
    dataLoading: boolean = false;    
    callbackError: any;
    twilioWorkerDisconnectedSnackBarRef: any;
    riEnabled: boolean = false;
    callbackElevatorId: any;
    editCallItem: any = { audioQuality: 0, videoQuality: 0, };
    ////elevatorInfoStatus: string = '';
    starArray: number[] = [];
    callDetailsList: any;    
    menu: any = {};
    togglesubmenu: any = {};
    params: any = {};
    deviceOptions: any = {};
    ////siteurl:any;
    ////tokenTTL = 3600; //Token TTL seconds
    ////refreshBuffer = 300; // Buffer time in seconds.
    incomingCallDialogRef!: MatDialogRef<IncomingCallComponent>;

    constructor(
        private _apiService: APIService,
        private _localCookies: CookieService,
        private _localDataService: LocalDataService,
        private router: Router,
        private _authenticationService: AuthenticationService,
        private _pushNotificationService: PushNotificationService,
        private _dialog: MatDialog,
        private _elevatorCallService: ElevatorCallService,
        private _commonService: CommonService, public _snackBar: MatSnackBar,
        private g3msService: G3msService,
        private _notificationService: NotificationService,
         private _router: Router
        //private _dialogRef: MatDialogRef<CallElevatorComponent>,
        ) {
            window.callBackElevatorIdField = true;
            window.addEventListener("beforeunload", function (e: any) {
                var confirmationMessage = "\o/";
                ////console.log("Call Hanged: ", window.callHanged);
                if (!window.callHanged) {
                    (e || window.event).returnValue = confirmationMessage;
                }
                return confirmationMessage;
            });
            window.addEventListener('online', () => {
            ////console.log('Back online - reinitializing Twilio');
            this.setupAudioCall();
            });
        }

    modifyMicGain(newValue: any) {
        let payload = { deviceType: this.deviceType, methodName: 'modifyMicGain', uuid: this.uuid, elevatorId: this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), value: newValue, micGain: this.elevatorControls.prevMicGain, speakerVolume: this.elevatorControls.prevSpeakerVolume };
        return this._apiService.post(payload, Constants.G3MS_URLS.modifyMicGain).subscribe({
            next: (result: any) => {
                if (!result.status) {
                    this._notificationService.showSnackBar(this.errorMsg(result), 'red');
                    // this._snackBar.open(this.errorMsg(result), 'Close', {
                    //     panelClass: ['otis-snackbar', 'red-snackbar'],
                    //     horizontalPosition: 'center',
                    //     verticalPosition: 'top',
                    // });
                    this.elevatorControls.micGain = parseInt(this.elevatorControls.prevMicGain);
                } else {
                    this.elevatorControls.prevMicGain = this.elevatorControls.micGain;
                }
            },
            error: (error: any) => {

            }
        });
    }
    modifySpeakerVolume(newValue: any) {
        let payload = { deviceType: this.deviceType, methodName: 'modifySpeakerVolume', uuid: this.uuid, elevatorId: this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), value: newValue, micGain: this.elevatorControls.prevMicGain, speakerVolume: this.elevatorControls.prevSpeakerVolume };
        this._apiService.post(payload, Constants.G3MS_URLS.modifySpeakerVolume).subscribe({
            next: (result: any) => {
                if (!result.status) {
                    this._notificationService.showSnackBar(this.errorMsg(result), 'red');
                    // this._snackBar.open(this.errorMsg(result), 'Close', {
                    //     panelClass: ['otis-snackbar', 'red-snackbar'],
                    //     horizontalPosition: 'center',
                    //     verticalPosition: 'top'
                    // });
                    this.elevatorControls.speakerVolume = parseInt(this.elevatorControls.prevSpeakerVolume);
                } else {
                    this.elevatorControls.prevSpeakerVolume = this.elevatorControls.speakerVolume;
                }
            },
            error: (error: any) => {

            }
        });
    }
    compareArrays(ct: any, cs: any) {
        var callType = ct.split(',');
        var commissioningState = cs.toString().split(',');

        var compareLength = 0;
        for (var i = 0; i < callType.length; i++) {
            if (commissioningState.indexOf(callType[i]) != -1) {
                compareLength = compareLength + 1;
            }
        }

        if (callType.length == compareLength) {
            return true;
        }
        return false;
    }    
    applyWorkerActivityChanges(data: any) {
        if(this._localDataService.ecd.currentUser?.callType)
        {
        var callType = this._localDataService.ecd.currentUser.callType != null ? this._localDataService.ecd.currentUser.callType : "";
        }
        this.agentStatusCountData = { available: 0, notAvailable: 0, offline: 0, inCall: 0, repeatedTPACallAlerts: 0 }
        this.agentStatusCount.next(this.agentStatusCountData);
        var totalAgent = 0;
        if (data != "") {
            var lookupAgent = [];
            var agentsForCount = [];

            try {
                for (var j = 0; j < this.agentDetails.length; j++) {
                    var item = this.agentDetails[j];

                    if (lookupAgent.indexOf(item.emailId) == -1) {
                        lookupAgent.push(item.emailId);
                        agentsForCount.push(item);

                        var syncData = data.filter((element: any) => {
                            if (element.data.callType == undefined) {
                                element.data.callType = "";
                            }

                            return "UserId" + item.userId === element.key && (this.compareArrays(callType, element.data.callType) || (callType.indexOf(this.callTypes[1].type) >= 0 && element.data.callType.indexOf(this.callTypes[1].type) >= 0))
                        });
                        if (syncData.length > 0) {
                            switch (syncData[0].descriptor.data.statusId) {
                                //Offline
                                case 2:
                                    this.agentStatusCountData.offline = this.agentStatusCountData.offline + 1;
                                    totalAgent = totalAgent + 1;
                                    break;
                                //Idle
                                case 1:
                                case 7:
                                    this.agentStatusCountData.available = this.agentStatusCountData.available + 1;
                                    totalAgent = totalAgent + 1;
                                    break;
                                //Not Available
                                case 3:
                                    this.agentStatusCountData.notAvailable = this.agentStatusCountData.notAvailable + 1;
                                    totalAgent = totalAgent + 1;
                                    break;
                                //Reserved
                                case 5:
                                    this.agentStatusCountData.inCall = this.agentStatusCountData.inCall + 1;
                                    totalAgent = totalAgent + 1;
                                    break;
                                //Busy
                                case 6:
                                    this.agentStatusCountData.inCall = this.agentStatusCountData.inCall + 1;
                                    totalAgent = totalAgent + 1;
                                    break;
                                //Nothing
                                default:
                                    break;
                            }
                        }
                    }
                }
                if (agentsForCount.length > 0) {
                    var totalCallTypeAgents = agentsForCount.filter(ele => {
                        if (callType.indexOf(",") > 0) {
                            return ele.callType.indexOf(this.callTypes[1].type) >= 0;
                        } else {
                            return this.compareArrays(callType, ele.callType) || (callType.indexOf(this.callTypes[1].type) >= 0 && ele.callType.indexOf(",") > 0);
                        }
                    });
                    this.agentStatusCountData.offline = this.agentStatusCountData.offline + (totalCallTypeAgents.length - totalAgent);

                    this.agentStatusCount.next({
                        available: this.agentStatusCountData.available,
                        notAvailable: this.agentStatusCountData.notAvailable,
                        offline: this.agentStatusCountData.offline,
                        inCall: this.agentStatusCountData.offline,
                        repeatedTPACallAlerts: this.agentStatusCountData.offline
                    });
                }
            }
            catch (e) {
                // console.log(e);
            }
        }
        // if (!$scope.$$phase) {
        //   $scope.$digest();
        // }
    };
    userLoginCookiesSet(result: any) { 
        return new Promise((resolve, reject) => {       
        // this will set the expiration to 1 day token validation
        var exp = Constants.GetCookieExpredDate(1);
        this._localDataService.ecd.currentUser = result.user;
        this._localDataService.ecd.currentUser["agentUniqueId"] = "Agent" + this._localDataService.ecd.currentUser.userID;
        Constants.APP_CONFIG.workflowTimeout = result.config.appConfig.timeout;

        if (result.user.roleId === 3 || result.user.roleId === 4 || result.user.roleId === 5 || result.user.roleId === 6 || this.router.url === "/join-room") {
            this.userStatusDisplay = false;
            if (result.user.roleId === 3) {
                this.admin = true;
            }            
        } else {
            this.userStatusDisplay = true;
            this.admin = false;
        }

        if (this._localDataService.ecd.currentUser != null) {
            this._localDataService.ecd.currentUser.enableNotAvailableReason = false;
            this._localDataService.ecd.currentUser.allowEditDispo = true;

            // // if (this._localDataService.ecd.currentUser.isAgent == 1) {
            // //     this.getUserForCountry();
            // // }
        }
        let role = Constants.USER_ROLES.filter((element: any) => {
            if (element.id === this._localDataService.ecd.currentUser.roleId) {
                return element;
            }
        })

        //Making that user is not on call
        this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "0");

        if (this.router.url.indexOf('/avaya-') >= 0 || this.router.url.toLowerCase().indexOf('/otislinepbx') >= 0) {
            result.user.usertype = 'avaya';
            localStorage.setItem('userType', 'avaya');

            this._localCookies.set(Constants.APPCOOKIES.CCC_LOGGEDTYPE, '' + (result.user.workerId == null ? result.user.userID : result.user.workerId), { expires: exp });
        }
        else {
            result.user.usertype = 'ccc';
            localStorage.setItem('userType', 'ccc');
            if (this._localCookies.get(Constants.APPCOOKIES.CCC_LOGGEDTYPE) != undefined) {
                this._localCookies.delete(Constants.APPCOOKIES.CCC_LOGGEDTYPE);
            }
        }        

        this._localCookies.set(Constants.APPCOOKIES.CCC_TOKEN, result.accToken, { expires: exp });
        this._localCookies.set(Constants.APPCOOKIES.CCC_COUNTRYID, result.user.countryId, { expires: exp });
        this._localCookies.set(Constants.APPCOOKIES.CCC_EMAILID, result.user.emailId, { expires: exp });
        this._localCookies.set(Constants.APPCOOKIES.CCC_SID, result.user.sId, { expires: exp });
        this._localCookies.set(Constants.APPCOOKIES.CCC_USERID, result.user.userID, { expires: exp });
        this._localCookies.set(Constants.APPCOOKIES.CCC_ROLEID, result.user.roleId, { expires: exp });
        this._localCookies.set(Constants.APPCOOKIES.CCC_ELEVATORID, (result.user.elevatorId == null ? "" : result.user.elevatorId), { expires: exp });
        this._localDataService.ecd.countryConfig = { "countryconfigId": (result.user.countryConfigurationId == null ? 0 : result.user.countryConfigurationId), "enableDataTracks": (result.user.enableDataTracks == null ? "true" : result.user.enableDataTracks + ""), "enableNotAvailableReason": (result.user.enableNotAvailableReason == null ? "true" : result.user.enableNotAvailableReason + ""), "enableCallDispo": (result.user.enableCallDispo == null ? "true" : result.user.enableCallDispo + "") };

        let appConfg = Constants.APP_CONFIG;
        let usrStatus = Constants.USER_CURRENT_STATUS;

        this._localDataService.ecd.languageId = result.user.languageId;
        this._localDataService.ecd.languageShortName = result.user.languageShortName;
        this._localDataService.ecd.dataRetension = result.user.days;

        if (result.config != null) {
            usrStatus[0].sId = result.config.appConfig.idleSid;            
            usrStatus[2].sId = result.config.appConfig.busySid;
            usrStatus[2].display = false;
            usrStatus[3].sId = result.config.appConfig.offlineSid;

            //binding SID data to constants user status
            Constants.USER_CURRENT_STATUS = usrStatus;

            //Modify app config      
            // // appConfg.busySid = result.config.appConfig.busySid;
            // // appConfg.deleteSid = result.config.appConfig.deleteSid;
            // // appConfg.offlineSid = result.config.appConfig.offlineSid;
            // // appConfg.reservSid = result.config.appConfig.reservSid;

            appConfg.busySid = environment.busySid.toString();
            appConfg.deleteSid = environment.deleteSid.toString();
            appConfg.offlineSid = environment.offlineSid.toString();
            appConfg.reservSid = environment.reservSid.toString();

            appConfg.audioCodec = result.config.appConfig.audioCodec == null ? 'pcmu' : result.config.appConfig.audioCodec;
            appConfg.videoCodec = result.config.appConfig.videoCodec == null ? 'H264' : result.config.appConfig.videoCodec;
            appConfg.switchOffLogs = result.config.appConfig.switchOffLogs;
        }

        appConfg.isOnlyAudio = !result.user.video;

        this.loggedOut = false;

        //binding APP_CONFIG data to constants user App CONFIG
        Constants.APP_CONFIG = appConfg;
        if (result.user.activityStatusId != undefined) {
            this._localDataService.ecd.statusId = result.user.activityStatusId;
        }
        this._localDataService.ecd.selectedCountryId = parseInt(result.user.countryId);
        this._localDataService.ecd.selectedCountryShortName = result.user.countryShortName;   

        this._localDataService.ecd.dateFormat = result.user.dateFormat;
        //this.$emit("changeCountry", this._localDataService.ecd.selectedCountryId);
        this._localDataService.ecd.selectedCountryName = this._localDataService.ecd.currentUser.countryName;
        this._localDataService.ecd.appData = {
            workers: {}
        };
        this._localDataService.ecd.appData.workers.identityToken = result.token;
        this._localDataService.ecd.appData.workers.workerToken = result.workerToken;
        this._localDataService.ecd.appData.menuHtml = result.menu;
        ////this._localDataService.ecd.appData.unmenuHtml = result.unmenu;
        this._localDataService.ecd.appData.linkMenuHtml = result.linkMenu;
        this._localDataService.ecd.callDispstnArry = result.callDispo;
        this.callDispstnArry = [...result.callDispo];
        this._localDataService.ecd.questionOriginalText = result.questionText;
        this._localDataService.ecd.notAvailableReason = {
            items: result.notAvailableReason,
            isAllDisabled: () => {
                let list = result.notAvailableReason.filter((element: any) => {
                    return element.enabled == true;
                });
                return list.length <= 0;
            }
        };

        this.shutdownReasonArry = result.shutdownReson;
        ////this._localDataService.ecd.questionOriginalText = result.questionText;
        //Assign countries
        //SELECTED_COUNTRY = result.selectedCountries;
        this._localDataService.ecd.SELECTED_COUNTRY = result.selectedCountries;
        this._localDataService.ecd.countryList = result.selectedCountries;
        this._localDataService.ecd.langaugeSkills = result.languageSkills;
        this.queueCountry = (this._localDataService.ecd.selectedCountryShortName != undefined ? this._localDataService.ecd.selectedCountryShortName.toLocaleLowerCase() : "");
        if (this._localDataService.ecd.currentUser.roleId != 3) {
            this.deviceCheck();
        }
        this.registerTaskRouterWorker(result);
        resolve(true);
        })

    }

    handleReservation (reservation: any) {
        this.clearCallDetails();
        //reservation timeout
        reservation.on("timeout", (timedoutReservation: any) => {
        this.makeUserAvailableIfOne(timedoutReservation)
        });
        //reservation canceled update the SID status in workers
        reservation.on("canceled", (reservation: any) => {
        this.updateWorkerActivityTwilio(this.userStatus[3].sId);
        this.makeUserAvailableIfOne(reservation);
        });
        reservation.on("accepted", (reservation: any) => {
        AppConfigService.trackEvent("twilio", { name: "AcceptTheCall:reservation.accepted" }, { "elevatorId": this.elevatorId, "extraDetails": " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) + " TaskSID: " + reservation.task.sid + " ReservationSID: " + reservation.sid, "message": "acceptTheCallAccepted", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
        });
        reservation.on("pending", () => {
        AppConfigService.trackEvent("twilio", { name: "reservation.on pending" }, { "elevatorId": this.elevatorId, "extraDetails": " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) + " TaskSID: " + reservation.task.sid + " ReservationSID: " + reservation.sid, "message": "acceptTheCallAccepted", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
        })
        reservation.on('failed', () => {
        AppConfigService.trackEvent("twilio", { name: "reservation failed" }, { "elevatorId": this.elevatorId, "extraDetails": " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) + " TaskSID: " + reservation.task.sid + " ReservationSID: " + reservation.sid, "message": "acceptTheCallAccepted", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
        })
        //Make all the popup invisible
        this.changeStatusConfrmModel = {
        display: Constants.APP_CONSTANTS.none
        };

        this.logoutConfrmModel = {
        display: Constants.APP_CONSTANTS.none
        };
        if (reservation.task.attributes && this._localDataService.ecd.currentUser) {      
        this._localDataService.ecd.currentUser.disableIncomingCallRejectbutton = false;
        reservation.task.attributes.taskId = reservation.task.sid;
        if (reservation.task.attributes[this._localDataService.ecd.currentUser["agentUniqueId"]] != undefined) {
            //check for the count
            var count = reservation.task.attributes[this._localDataService.ecd.currentUser["agentUniqueId"]]
            this._localDataService.ecd.currentUser.rejectCount = count;
            if (count <= 0) {
            //Disable reject button
            this._localDataService.ecd.currentUser.disableIncomingCallRejectbutton = true;
            }
        } else {
            ////reservation.task.attributes[this._localDataService.ecd.currentUser["agentUniqueId"]] = this._localDataService.getRejectCallLimit();
        }
        }
        let displayElevatorId = reservation.task.attributes.display_unit_number;
        this.elevatorCarId = reservation.task.attributes.car_id;
        reservation.task.attributes.display_elevator_id = reservation.task.attributes.elevator_id;
        if (displayElevatorId != null) {
        if (displayElevatorId.trim().toLowerCase() != 'unknown' && displayElevatorId.trim() != '') {
            reservation.task.attributes.display_elevator_id = displayElevatorId;
        }
        }

        this.call = {
        display_elevator_id: reservation.task.attributes.display_elevator_id
        };

        if (reservation.task.attributes.preferred_video_codec != null) {
        this.temp.preferredVideoCodecs = [reservation.task.attributes.preferred_video_codec];
        } else {
        this.temp.preferredVideoCodecs = ["H264"];
        }
        this.remoteParticipantSid = null;
        this.callTransferer = "";
        if (!this._localDataService.ecd.callAccept || this._localDataService.ecd.viewDetails) {

            //To maximize video control in video call page
            this.localControls = {
                max: this._localCookies.get(this._localDataService.ecd.currentUser.userID + Constants.APPCOOKIES.VIDEO_CONTROL_PREFERENCE) == "" || this._localCookies.get(this._localDataService.ecd.currentUser.userID + Constants.APPCOOKIES.VIDEO_CONTROL_PREFERENCE) == undefined ? true : this._localCookies.get(this._localDataService.ecd.currentUser.userID + Constants.APPCOOKIES.VIDEO_CONTROL_PREFERENCE) == "true"
            };
            /*
            Push notification to show the notification to the Agent, if CCC window/tab is not opened.
            It will show the popup to user about CallIncoming or Call timeout
            */
            this._pushNotificationService.showNotification({
                unitId: reservation.task.attributes.display_elevator_id,
                body: `${('incomingCall')}: ${reservation.task.attributes.display_elevator_id}`,
                timeout: Constants.PAGE_CONSTANTS.home.getVisualAlertTimeout(Constants.APP_CONFIG.workflowTimeout),
                isHidden: true
            });
            this._localCookies.set(Constants.APPCONSTANTS.lastElevatorId, reservation.task.attributes.display_elevator_id);
            //this.bindToDropdown(this._localDataService.ecd.questionOriginalText);
            this.audioTrackAdded = false;
            //$("#remote-media").find("video").remove();
            this._localDataService.ecd.statusId = 5;
            this.targetWorker = "";
            this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "1");
            if (reservation.task.attributes.target_worker != null) {
                this.callTransferer = reservation.task.attributes.call_transfer;
            }

            this.currentTask = reservation.task;
            this.taskSid = reservation.task.sid;

            this.voiceCallType = 1;
            this._localCookies.set(Constants.APPCOOKIES.CCC_ALARMID, reservation.task.attributes.alarm_id);
            let details = " Worker name is " + this._localDataService.ecd.currentUser.name + " task age is " + reservation.task.age + ", task SID is " + reservation.task.sid + ", alarmID is " + reservation.task.attributes.alarm_id + " and task attribute is " + JSON.stringify(reservation.task.attributes);
            AppConfigService.trackEvent("twilio", { name: "reservation.created" }, { "methodName": "reservation.created", "elevatorId": reservation.task.attributes.elevator_id, "extraDetails": details, "message": "reservCreated", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });

            if (reservation.task.attributes.texting_enable == "true") {
                if (this._localDataService.ecd.countryConfig) {
                this._localDataService.ecd.countryConfig.enableDataTracks = reservation.task.attributes.texting_enable;
                this._localDataService.ecd.countryConfig.textingEnabled = true;
                }
                else {
                this._localDataService.ecd.countryConfig = { enableDataTracks: reservation.task.attributes.texting_enable, textingEnabled: true };
                }
            }
            else {
                if (this._localDataService.ecd.countryConfig) {
                this._localDataService.ecd.countryConfig.enableDataTracks = reservation.task.attributes.texting_enable;
                this._localDataService.ecd.countryConfig.textingEnabled = false;
                }
                else {
                this._localDataService.ecd.countryConfig = { enableDataTracks: reservation.task.attributes.texting_enable, textingEnabled: false };
                }
            }

            this.currentReservation = reservation;
            //   console.log("Task Details : Country - " + reservation.task.attributes.country + ", Elevator ID - " + reservation.task.attributes.elevator_id);

            if (reservation.task.attributes.room_name != null && reservation.task.attributes.room_name != "") {
                this.roomName = reservation.task.attributes.room_name;
            } else {
                this.roomName = reservation.task.attributes.elevator_id;
            }

            this.elevatorId = reservation.task.attributes.elevator_id;

            this.failureReasonCode = reservation.task.attributes.failure;
            let shutdownReason = this.shutdownReasonArry.filter((item: any) => {
                return item.code == reservation.task.attributes.failure;
            });

            if (shutdownReason.length > 0) {
                reservation.task.attributes.failure = shutdownReason[0].shutdownReason;
            }
            reservation.task.attributes.taskAge = reservation.task.age;
            this.callInitiator = Constants.APP_CONFIG.callInitiator;
            reservation.task.attributes.taskSid = reservation.task.sid;
            reservation.task.attributes.isDBGenerated = 0;
            let customUTCDate = this._commonService.getConvertedUTCDate(reservation.task.dateCreated);

            reservation.task.attributes.taskCreatedOn = customUTCDate.fromDate;
            reservation.task.attributes.uniqueId = reservation.task.attributes.alarm_id + '-' + Math.random();
            this._localDataService.ecd.callUniqueId = reservation.task.attributes.uniqueId;
            //this.$emit("callEvents", "incoming");

            // Call twilio updating status to update the worker as reserved as multitasking is disabled
            this.agent.selectedStatus = "Reserved";
            this.agent.prevSelStatus = "Reserved";
            this.agentStatusEmit.next({
                selectedStatus: this.agent.selectedStatus,
                prevSelStatus: this.agent.prevSelStatus,
                onCallbackStatus: this.agent.onCallbackStatus
            });

            if (!this.loggedOut && this.syncClient != null) {
                ////this.updateSyncClient(this._localDataService.ecd.currentUser.userID, this._localDataService.ecd.currentUser.name, this.agent.selectedStatus, this._localDataService.ecd.statusId, this._localDataService.ecd.currentUser.callType);
                this.updateSyncClient(this._localDataService.ecd.currentUser.userID, this._localDataService.ecd.currentUser.name, this.agent.selectedStatus, this._localDataService.ecd.statusId);
            }

            // After reserving call pop-up the call making as false
            this.isTimeout = false;
            this.notifiTimeLeft = Constants.APP_CONFIG.workflowTimeout;
            this.clearCallDetails();
            AppConfigService.trackEvent("twilio", { name: "reservationCreated before initiateCallNotificationPopup " }, { ...reservation.task.attributes });
            this.initiateCallNotificationPopup(reservation.task.attributes, true, false);
        }
    }

    registerTaskRouterWorker(result: any) {
        try {
         AppConfigService.trackEvent('twilio', { name: "registerTaskRouterWorker"});
        }
        catch (e) {
            ////console.log("error:",e);
        }
        
        //Twilio Connection
        this._localDataService.ecd.currentUser.isTwilioLoaded = false;        
        //Variables for callback
        this.callBackInline = false;
        let isCallBackInitiated = false;
        this.workerSid = result.user.sId;
        if (this._localDataService.ecd.currentUser.isAgent !== 0) {
            this._localDataService.ecd.currentUser.allowedNotify = false;
            this._authenticationService.getWorkerToken(result.user.sId,`${result.user.userID}-${result.user.name}`).subscribe({
                next: (workerResult: any) => {
                    if (!workerResult.body.status) return;

                    if (workerResult.body.workToken == undefined) return;

                    //TODO
                    //Get notification is granded
                    this._localDataService.ecd.currentUser.allowedNotify = this._pushNotificationService.isNotificationAllowed;
                    //Init notification
                    this._pushNotificationService.init();
                    this.worker = new TaskRouter.Worker(workerResult.body.workToken,
                        {connectActivitySid: "",
                        //logLevel: "debug",
                        closeExistingSessions: true,
                        setWorkerOfflineIfDisconnected: true
                    }
                    );
                    this.workerToken = workerResult.body.workToken;
                    this.syncClient = new Client(workerResult.body.syncToken);
                    //To update userIdentity sync client for supervisor dashboard activities
                    this.updateSyncClient = function (userId, name, status, statusId) {
                        ////, callType
                        this.syncClient.map('UserIdentity' + this._localDataService.ecd.currentUser.countryConfigurationId).then((map: any) => {
                            map.update("UserId" + userId, { "name": name, "status": status, "statusId": statusId});
                            ////map.update("UserId" + userId, { "name": name, "status": status, "statusId": statusId, "datetime": this.callStartedDateTime = this._commonService.getUTC()});
                            //_commonService.getUTC("YYYY-MM-DDTHH:mm:ss")+ "Z"});
                            ////"callType": callType, 
                            //map.update("UserId" + userId, { "name": name, "status": status, "statusId": statusId, "callType": callType, "datetime": this.callStartedDateTime = (this._commonService.getConvertedUTCDate(new Date()).fromDate) + "Z" });
                        });
                    }

                    this.syncClient.on("endpoint_disconnected", (err: any, err1: any) => {
                        console.log("Endpoint disconnected: ", err, err1);
                    });

                    this.syncClient.on("endpoint_connected", (err: any, err1: any) => {
                        console.log("Endpoint connected: ", err, err1);
                    });

                    this.pingServerCancelTimeout = null;
                    this.syncTimerCount = 0;
                    this.insertClientAvailable(workerResult.body);
                    this.syncClient.document('CallEvent-' + this._localDataService.ecd.currentUser.countryConfigurationId).then((doc: any) => { });
                    this.syncClient.map('UserIdentity' + this._localDataService.ecd.currentUser.countryConfigurationId)
                        .then((map: any) => {
                            ////console.log('ttl',this._commonService.convertToSecs(this._localDataService.ecd.currentUser.userSessionExpMins)) ;
                            //this._commonService.convertToSecs(this._localDataService.ecd.currentUser.userSessionExpMins)                      
                            return map.set("UserId" + this._localDataService.ecd.currentUser.userID, { "name": this._localDataService.ecd.currentUser.name, "status": "Offline", "statusId": this._localDataService.ecd.statusId }, { ttl: this._commonService.convertToSecs(1440)});
                            ////, "callType": this._localDataService.ecd.currentUser.callType
                        })
                        .then(function (updateResult: any) {
                        })
                        .catch(function (error: any) {
                        });

                    if (this._localDataService.ecd.currentUser.roleId == 2 || this._localDataService.ecd.currentUser.roleId == 1) {
                        this.syncClient.map('UserIdentity' + this._localDataService.ecd.currentUser.countryConfigurationId).then((map: any) => {
                            map.on("itemAdded", (data: any) => {
                                this.getActivityChanges();
                            });
                            map.on("itemUpdated", (data: any) => {
                                this.getActivityChanges();
                            });

                            map.on('itemRemoved', (item: any) => {
                                this.getActivityChanges();
                            });
                        });

                        this.syncClient.document('CallEvent-' + this._localDataService.ecd.currentUser.countryConfigurationId).then((doc: any) => {
                            doc.on("updated", (data: any) => {
                                if (!data.isLocal) {                                    
                                }
                            });
                        });
                    }

                    this.syncClient.on('tokenExpired', () => {
                        console.log("Token is expired.....: ", this.syncTimerCount);
                        this._commonService.logMessage({ "methodName": "tokenExpired", "message": "Token is expired, timer count: " + this.syncTimerCount, userDefined: true, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        this._authenticationService.getWorkerToken(this.workerSid,this.identity).subscribe((expToken: any) => {
                            this.syncTimerCount = 0;
                             if (expToken?.body?.syncToken)
                            this.syncClient.updateToken(expToken.body.syncToken);
                        });
                    });

                    this.syncClient.on('tokenAboutToExpire', () => {
                        this._commonService.logMessage({ "methodName": "tokenAboutToExpire", "message": "Token is going to get expire, timer count: " + this.syncTimerCount, userDefined: true, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        this._authenticationService.getWorkerToken(this.workerSid,this.identity).subscribe((expToken: any) => {
                            this.syncTimerCount = 0;
                            if (expToken?.body?.syncToken)
                            this.syncClient.updateToken(expToken.body.syncToken);
                        });
                    });                    
                    
                    this.syncClient.map(Constants.APP_CONFIG.taskQueueKey + this.queueCountry)
                        .then((map: any) => { })
                        .then((updateResult: any) => {
                            this.getItemFromMap();
                        });

                    this.syncClient.map(Constants.APP_CONFIG.taskQueueKey + this.queueCountry).then((map: any) => {
                        map.on("itemAdded", (data: any) => {
                            this.getItemFromMap(true);
                        });

                        map.on('itemRemoved', (item: any) => {
                            this.getItemFromMap();
                        });
                    });

                    //this.insertClientAvailable(workerResult.body);
                    this.worker.on("ready", (twilWorker: any) => {
                        this._localDataService.ecd.currentUser.isTwilioLoaded = true;
                        this.logWSDisconnect(this.home.isOnline, true);
                        this.home.isOnline = true;
                        this.agent.selectedStatus = twilWorker.activity.name;
                        this.agent.prevSelStatus = twilWorker.activity.name;
                        this.agent.onCallbackStatus = twilWorker.activity.name;

                        //Make assigned task as complete
                        twilWorker.reservations.forEach((reserv: any) => {
                        if (reserv.status == "pending") {
                            this.handleReservation(reserv);
                        }
                        if (reserv.status == "accepted") {
                            //complete reservation
                            reserv.task.complete(reserv.task.sid);
                        }
                        });

                        this.identity = twilWorker.friendlyName;
                        switch (twilWorker.activity.name) {
                            case "Busy":
                                //change the status
                                this._localDataService.ecd.statusId = 6;
                                //Update user to available if user is busy and refreshed the page
                                this.updateWorkerActivityTwilio(this.userStatus[0].sId);
                                break;
                            case "Reserved":
                                //change the status
                                this._localDataService.ecd.statusId = 5;
                                break;
                            case "Idle":
                                this._localDataService.ecd.statusId = 7;
                                this.agent.onCallbackStatus = twilWorker.activity.name;
                                break;
                            case "Offline":
                                this._localDataService.ecd.statusId = 3;
                                this.agent.onCallbackStatus = twilWorker.activity.name;
                                break;
                            default:
                                break;
                            }
                         //Newly added code
                        this.agentStatusEmit.next({
                        selectedStatus: this.agent.selectedStatus,
                        prevSelStatus: this.agent.prevSelStatus,
                        onCallbackStatus: this.agent.onCallbackStatus
                        })
                        if (this._localDataService.ecd.currentUser.roleId == 2 && (this._localCookies.get('refreshCookie'))==''){
                            this._localCookies.set('refreshCookie', "Refreshed");
                            this.agent.selectedStatus = this.userStatus[3].status;
                            this.agent.prevSelStatus = this.userStatus[3].status;
                            this.agent.onCallbackStatus = this.userStatus[3].status;
                            this.changeStatus("Offline", false)
                        }
                        else {
                            //console.log('Test Message:',this._localCookies.get('refreshCookie'));
                            this.agent.selectedStatus = twilWorker.activity.name;
                            this.agent.prevSelStatus = twilWorker.activity.name;
                            this.agent.onCallbackStatus = twilWorker.activity.name;
                            if (twilWorker.activity.name == "Idle") {
                                //Make assigned task as complete
                                this.completeAssignedTask();
                            }
                        }                        
                        this.identity = twilWorker.friendlyName;
                        if (twilWorker.activity.name == "Idle" && this.syncClient != null) {
                            let userId = this._localCookies.get(Constants.APPCOOKIES.CCC_USERID);
                            ////this._localDataService.ecd.statusId = 2;
                            this.updateSyncClient(userId, this._localDataService.ecd.currentUser.name, twilWorker.activity.name, 7);
                            ////, this._localDataService.ecd.currentUser.callType
                        }                        
                        this.setupAudioCall();

                    });
                    this.worker.on("connected", (err: any) => {
                        AppConfigService.trackEvent("twilio", { name: "worker.on connected - Websocket has connected - Worker has connected" }, { "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        this.logWSDisconnect(this.home.isOnline, true);
                        this.home.isOnline = true;
                    });

                    this.worker.on("disconnected", (err: any) => {

                        //commonService.logException({ "methodName": "worker.disconnected", "exceptionDetails": message.message + (this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) != null? " AlarmID: "+ this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID): ""), "elevatorId":  this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID)});
                        this.logWSDisconnect(this.home.isOnline, false);
                        this.home.isOnline = false;
                    });

                    this.worker.on("error", (error: any) => {

                        if (error.message) {
                            //this._commonService.logException({ "methodName": "token.expired", "exceptionDetails": error.message, "extraDetails": " Worker name is: " + this._localDataService.ecd.currentUser.name, "message": "workerTokenExpired", "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        }
                        else {
                            // console.log(error)
                        }
                    });

                    this.worker.on("tokenExpired", (error: any) => {

                        if (error?.message) {
                            this._commonService.logException({ "methodName": "token.expired", "exceptionDetails": error.message, "extraDetails": " Worker name is: " + this._localDataService.ecd.currentUser.name, "message": "workerTokenExpired", "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        }
                        else {
                            ////console.log(error)
                        }
                        let currentsysdatenow = new Date();
                        //console.log('worker tokenExpired occured:',currentsysdatenow);
                        this.updateWorkerToken();
                    });
                    /*
                        this is the landing page when call come to CCC 
                        reservationCreated , to identify when a Worker has been matched to a Task
                    **/
                    this.worker.on("reservationCreated", (reservation: any) => {
                        this.clearCallDetails();
                        ////console.log('reservation reservationCreated');                        
                        this.agent.selectedStatus = "Busy";
                        this.agent.prevSelStatus = "Idle";
                        this.agentStatusEmit.next({
                            selectedStatus: this.agent.selectedStatus,
                            prevSelStatus: this.agent.prevSelStatus,
                            onCallbackStatus: this.agent.onCallbackStatus
                        });                        
                        this.callTransferer="";
                        this.callStartedSecs = 0;
                        this.callConnected=false;
                        this.toggleCallElevator(true);
                        this._localDataService.ecd.statusId = 5;
                        //reservation timeout
                        //reservation canceled update the SID status in workers
                        reservation.on("timeout", (reservation: any) => {
                            console.log('reservation timeout', reservation);
                            this._localCookies.set("CCApp-isOngoingCall", "0");
                            this.callHanged = true;
                            this.makeUserAvailableIfOne(reservation);
                            ////this.updateActivity(Constants.APP_CONFIG.busySid);
                        });
                        reservation.on("accepted", (accpetreservation: any) => {
                            ////console.log('Reservationaccepted', reservation);
                            this.AgentHanged=false;
                            this._commonService.logMessage({ "methodName": "AcceptTheCall:reservation.accepted", "elevatorId": this.elevatorId, "extraDetails": " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) + " TaskSID: " + reservation.task.sid + " ReservationSID: " + reservation.sid, "message": "acceptTheCallAccepted", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                            ////this.keepAliveInterval = setInterval(this.sendTone, 30000);
                            this.keepAliveInterval = setInterval(()=>{
                                this.sendTone(this.phoneConnection);
                            }, 30000);                             
                            this.updateActivity(Constants.APP_CONFIG.busySid);                                                        
                        });
                        reservation.on("pending", () => {
                            console.log('Reservation pending');
                        })
                        reservation.on('failed', () => {
                            ////console.log('Reservation failed')
                        })
                        this.silenceText = ('silence');
                        this.silenceImgPath = '../images/call-elevator/silence.png';

                        let timer = {
                            showCallTimer: true
                        };

                        if (this.loginTime != null) {
                            let secs = this._commonService.secondsDiff(this.loginTime);
                            if (secs <= 10) {
                                timer = {
                                    showCallTimer: false
                                };
                            }
                        }

                        //Make all the popup invisible
                        this.changeStatusConfrmModel = {
                            display: Constants.APP_CONSTANTS.none
                        };                        

                        this.logoutConfrmModel = {
                            display: Constants.APP_CONSTANTS.none
                        };
                        let displayElevatorId = (reservation.task.attributes.display_unit_number== "" || reservation.task.attributes.display_unit_number == undefined)?reservation.task.attributes.elevator_id:reservation.task.attributes.display_unit_number;
                        reservation.task.attributes.display_elevator_id = reservation.task.attributes.elevator_id;
                        if (displayElevatorId != null) {
                            if (displayElevatorId.trim().toLowerCase() != 'unknown' && displayElevatorId.trim() != '') {
                                reservation.task.attributes.display_elevator_id = displayElevatorId;
                            }
                        }

                        this.call = {
                            display_elevator_id: (reservation.task.attributes.display_elevator_id=== "")?reservation.task.attributes.elevator_id:reservation.task.attributes.display_elevator_id,
                        };
                        this.remoteParticipantSid = null;                        
                        this.callTransferer = "";
                        this.toggleCallElevator(true);

                        if (!this._localDataService.ecd.callAccept || this._localDataService.ecd.viewDetails) {

                            //To maximize video control in video call page
                            this.localControls = {
                                max: this._localCookies.get(this._localDataService.ecd.currentUser.userID + Constants.APPCOOKIES.VIDEO_CONTROL_PREFERENCE) == "" || this._localCookies.get(this._localDataService.ecd.currentUser.userID + Constants.APPCOOKIES.VIDEO_CONTROL_PREFERENCE) == undefined ? true : this._localCookies.get(this._localDataService.ecd.currentUser.userID + Constants.APPCOOKIES.VIDEO_CONTROL_PREFERENCE) == "true"
                            };

                            this._localCookies.set(Constants.APPCONSTANTS.lastElevatorId, reservation.task.attributes.display_elevator_id);
                            this.audioTrackAdded = false;
                            this.targetWorker = "";
                            this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "1");
                            if (reservation.task.attributes.target_worker != null) {
                                this.callTransferer = reservation.task.attributes.call_transfer;
                            }

                            this.currentTask = reservation.task;
                            this.taskSid = reservation.task.sid;
                            this.taskAttributes = reservation.task.attributes

                            this.voiceCallType = 1;
                            this._localCookies.set(Constants.APPCOOKIES.CCC_ALARMID, reservation.task.attributes.alarm_id);
                            let details = " Worker name is " + this._localDataService.ecd.currentUser.name + " task age is " + reservation.task.age + ", task SID is " + reservation.task.sid + ", alarmID is " + reservation.task.attributes.alarm_id + " and task attribute is " + JSON.stringify(reservation.task.attributes);
                            this._commonService.logMessage({ "methodName": "reservation.created", "elevatorId": reservation.task.attributes.elevator_id, "extraDetails": details, "message": "reservCreated", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) })

                            if (reservation.task.attributes.texting_enable == "true") {
                                if (this._localDataService.ecd.countryConfig) {
                                    this._localDataService.ecd.countryConfig.enableDataTracks = reservation.task.attributes.texting_enable;
                                    this._localDataService.ecd.countryConfig.textingEnabled = true;
                                }
                                else {
                                    this._localDataService.ecd.countryConfig = { enableDataTracks: reservation.task.attributes.texting_enable, textingEnabled: true };
                                }
                            }
                            else {
                                if (this._localDataService.ecd.countryConfig) {
                                    this._localDataService.ecd.countryConfig.enableDataTracks = reservation.task.attributes.texting_enable;
                                    this._localDataService.ecd.countryConfig.textingEnabled = false;
                                }
                                else {
                                    this._localDataService.ecd.countryConfig = { enableDataTracks: reservation.task.attributes.texting_enable, textingEnabled: false };
                                }
                            }                            
                            this.currentReservation = reservation;
                            this.elevatorId = reservation.task.attributes.elevator_id;

                            if (reservation.task.attributes.room_name != null && reservation.task.attributes.room_name != "") {
                                this.roomName = reservation.task.attributes.room_name;
                            } else {
                                this.roomName = reservation.task.attributes.elevator_id;
                            }
                            this.isAutoDialer = 0;
                            this.isModelId=0;
                            if (reservation.task.attributes.isAutoDialer == '1') {
                                this.isAutoDialer = 1;
                            }
                            if (reservation.task.attributes.model_id !='' || reservation.task.attributes.model_id != null)
                            {
                                this.isModelId=reservation.task.attributes.model_id;
                            }
                            this._commonService.logMessage({
                                "Task Details : Country - ": reservation.task.attributes.country +
                                    ", Elevator ID - " + reservation.task.attributes.elevator_id
                            })

                            if (this.toggle) {
                                this.toggle = !this.toggle;
                            }
                            this.failureReasonCode = reservation.task.attributes.failure;
                            let shutdownReason = this.shutdownReasonArry.filter((item: any) => {
                                return item.code == reservation.task.attributes.failure;
                            });

                            if (shutdownReason.length > 0) {
                                reservation.task.attributes.failure = shutdownReason[0].shutdownReason;
                            }
                            reservation.task.attributes.taskAge = reservation.task.age;
                            this.callInitiator = Constants.APP_CONFIG.callInitiator;
                            reservation.task.attributes.taskSid = reservation.task.sid;
                            reservation.task.attributes.isDBGenerated = 0;
                            let customUTCDate = this._commonService.getConvertedUTCDate(reservation.task.dateCreated);

                            reservation.task.attributes.taskCreatedOn = customUTCDate.fromDate;
                            reservation.task.attributes.uniqueId = reservation.task.attributes.alarm_id + '-' + Math.random();
                            this._localDataService.ecd.callUniqueId = reservation.task.attributes.uniqueId;
                            /*
                            Push notification to show the notification to the Agent, if CCC window/tab is not opened.
                            It will show the popup to user about CallIncoming or Call timeout
                            */
                            this._pushNotificationService.showNotification({
                            unitId: reservation.task.attributes.display_elevator_id,
                            body: `${('Incoming Call')}: ${reservation.task.attributes.display_elevator_id}`,
                            timeout: Constants.PAGE_CONSTANTS.home.getVisualAlertTimeout(Constants.APP_CONFIG.workflowTimeout),
                            isHidden: true
                            });
                            //New code
                            ///////this.callNotifiModal.next({ 'style': 'block' });
                            // After reserving call pop-up the call making as false
                            this.isTimeout = false;
                            this.notifiTimeLeft = Constants.APP_CONFIG.workflowTimeout;
                            this.initiateCallNotificationPopup(reservation.task.attributes, true, false);
                        }
                    });

                    //Version 1 code is worker.on("task.canceled"
                    //Version 2 code written here.
                    this.worker.on("taskCanceled", (task: any) => {
                        ////console.log("Task Cancelled: ", task);
                    });

                    this.worker.on("activityUpdated", (twilWorker: any) => {
                        setTimeout(() => {                            
                            this._notificationService.hideSnackBar();
                        }, 5000);
                        ////console.log('activityupdate:', twilWorker)
                        this.agent.selectedStatus = twilWorker.activity.name;
                        this.agent.prevSelStatus = twilWorker.activity.name;
                        
                        this.agentStatusEmit.next({
                            selectedStatus: this.agent.selectedStatus,
                            prevSelStatus: this.agent.prevSelStatus,
                            onCallbackStatus: this.agent.onCallbackStatus
                        })

                        this.logWSDisconnect(this.home.isOnline, true);
                        if (twilWorker.activity.name == "Idle") {
                            this.callNotifiModal.next({ 'style': 'none' });
                            this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "0");
                        }
                        if (!this.loggedOut && this.syncClient != null) {
                            ////console.log('logoutsync status', this._localDataService.ecd.statusId)
                            this.updateSyncClient(this._localDataService.ecd.currentUser.userID, this._localDataService.ecd.currentUser.name, this.agent.selectedStatus, this._localDataService.ecd.statusId);
                            ////, this._localDataService.ecd.currentUser.callType
                        }
                        ////console.log("Worker - " + twilWorker.friendlyName + " status Changed : " + twilWorker.activity.name);

                        switch (twilWorker.activity.name) {
                            case "Busy":
                                //change the status
                                this._localDataService.ecd.statusId = 6;
                                 //Update user to available if user is busy and refreshed the page
                                /////this.updateWorkerActivityTwilio(this.userStatus[0].sId);
                                break;
                            case "Reserved":
                                //change the status
                                this._localDataService.ecd.statusId = 5;
                                break;
                            case "Idle":
                                this._localDataService.ecd.statusId = 1;
                                this.identity = twilWorker.friendlyName;
                                this.agent.onCallbackStatus = twilWorker.activity.name;
                                ////this.completeAssignedTask();
                                if (this.syncClient != null) {
                                    // To Initialize SyncClient.document
                                    //To receive and popup in supervisor screen, if any agent is goes offline/ not available
                                    if (this._localDataService.ecd.currentUser?.callType.indexOf(this.callTypes[1].type) >= 0) {
                                        this.syncClient.document('AgentOffline-' + this._localDataService.ecd.currentUser.countryId + '').then((doc: any) => {
                                            doc.set({ userId: this._localDataService.ecd.currentUser.userID, event: "Available", source: "2936" });
                                            
                                        });
                                    }
                                }
                                this.completeAssignedTask();
                                break;
                            case "Offline":
                                ////*this._localDataService.ecd.statusId = 3;
                                this.agent.onCallbackStatus = twilWorker.activity.name;
                                break;
                            default:
                                break;
                        }
                        //New code
                        this.agentStatusEmit.next({
                            selectedStatus: this.agent.selectedStatus,
                            prevSelStatus: this.agent.prevSelStatus,
                            onCallbackStatus: this.agent.onCallbackStatus
                        })
                        if (!this.loggedOut && this.syncClient != null && this._localDataService.ecd.currentUser != null) {
                            ////console.log('activityUpdated status:', twilWorker.activity.name);
                            this.updateSyncClient(this._localDataService.ecd.currentUser.userID, this._localDataService.ecd.currentUser.name, twilWorker.activity.name, this._localDataService.ecd.statusId);
                            ////, this._localDataService.ecd.currentUser.callType
                        }
                    });
                }
            })
        } 
        else 
        {
            this.identity = this._localDataService.ecd.currentUser.name;            
        }
    
    }
    closePushNotification(tag: any = null) {
        this._pushNotificationService.closeNotification(tag);
        this._dialog.closeAll();
    }
    /// Accept The Call
    acceptTheCall() {
        this.incomingCallDialogRef?.close();
        var isTestCall = false;
        var dispositionId = 0;
        this.controls = { showMessage: false, showStats: false }
        this._notificationService.showSnackBar("joining");
        
        ////Delete the task from Sync Map
        this.deleteItemFromMap(this.elevatorId);

        //1. Get the string for this code
        //get country details here
        var shutdownReason = this.shutdownReasonArry.filter((item: any) => {
            return item.code == this.failureReasonCode;
        });

        let callDispo = this.callDispstnArry.filter((item: any) => {
            return item.shutdownReasonCode == this.failureReasonCode;
        });

        var filterArray = {};
        if (callDispo.length == 1) {
            isTestCall = true;
            dispositionId = callDispo[0].callDispositionId;
        }

        if (callDispo.length > 1) {
            filterArray = { shutdownReasonCode: this.failureReasonCode };
        }

        //find out the call disposition Id & is it been able to change
        this.callDispoDetails = {
            callDispositionId: dispositionId + "",
            videoQuality: 0,
            audioQuality: 0,
            notes: "",
            isTestCall: isTestCall,
            filterOnly: filterArray
        };

        this.dataLoading = true;       
        
        this.accceptTask((returnStatus: any) => {
            if (returnStatus) {
                this.callCurrentStatus=1;
                this.callStartedSecs=0;
                ////console.log('accept task return status:', returnStatus);
                this._localDataService.ecd.callAccept = true;
                 this.incomingCallDialogRef?.close();
                 this.getCallDetails();
                this.callNotificationModal.next(true);                  
                //close call notification modal
                //this.callNotifiModal.next({ 'style': 'none' });                
                //////this.getCallDetails();
                this._localDataService.ecd.selectedStatus=6;
                this.router.navigate(['/ongoing-elevator-call']);                
            }
        });
        ////this.updateWorkerActivityTwilio(this.userStatus[2].sId);     
        this.createConference();//R2C
              
    };
    sendTone(manua:any) {
        if (this.phoneConnection && this.phoneConnection.status() === 'open') {
            if(this.isModelId==2)
            {
            this.phoneConnection?.sendDigits('0');
            }
            else{
            this.phoneConnection?.sendDigits('1');
            }
            //console.log('phoneConnection sendDigits:',1);
            // let currentsysdatenow = new Date();
            // console.log('Current phoneConnection:',currentsysdatenow); 
        }
        else if (!this.phoneConnection)
        {
            ////console.log('no phone sendDigits');
        }
        else if (this.manualConnection && this.manualConnection.status() === 'open') {
            this.manualConnection?.sendDigits('1');  
            ////console.log('manualConnection sendDigits:',1);          
        }  
        else if (!this.manualConnection) {
             ////console.log('no manual sendDigits');          
        }      
    }
    sendTone1(manua:any) {
        if (this.manualConnection && this.manualConnection.status() === 'open') {
            if(this.isModelId==2)
            {
                this.manualConnection?.sendDigits('0');
            }            
            else{
                this.manualConnection?.sendDigits('1');
            }
            ////console.log('manualConnection sendDigits:',1);           
        }    
    }
     
    checkConnectionStatus1() {
        if (this.call.status() == 'ringing') {
            this.call.disconnect();
        }
    }
    createConference() {
        if (this.currentReservation) {
            try {
                var siteurl=environment.siteUrl.toString();
                if(this.currentReservation && this.currentReservation.status==="pending")
                    {
                    this.Reservationerror=false;
                    ////console.log('createConference:', this.currentReservation);
                        if(this.isModelId==2)
                        {
                            this.currentReservation.redirect(
                                this.currentReservation.task.attributes.call_sid,                    
                                siteurl + "api/tpa/voiceconferenceAD/"
                                + this.currentReservation._worker.name + "/" + this.currentReservation.task.sid,
                                {accept:true}, (error: any, reservationDetails: any) => {
                                    if (error) {
                                        ////console.log("error: " + JSON.stringify(error));
                                        AppConfigService.trackException("twilio", { exception: new Error(JSON.stringify({ "methodName": "AcceptTheCall.currentReservation.accept", "exceptionDetails": `Error: ${error?.message}. Error Code: ${error?.code}. AlarmID: ${this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID)}`, "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) })), severityLevel: SeverityLevel.Critical });                            
                                        return;
                                    }
                                    ////console.log("Reservation redirected", error);
                                    ////console.log('reservationDetails', reservationDetails);
                                });}
                            else{
                                this.currentReservation.redirect(
                                this.currentReservation.task.attributes.call_sid,                    
                                siteurl + "api/tpa/voiceconference/"
                                + this.currentReservation._worker.name + "/" + this.currentReservation.task.sid,
                                {accept:true}, (error: any, reservationDetails: any) => {
                                    if (error) {
                                        ////console.log("error: " + JSON.stringify(error));
                                        AppConfigService.trackException("twilio", { exception: new Error(JSON.stringify({ "methodName": "AcceptTheCall.currentReservation.accept", "exceptionDetails": `Error: ${error?.message}. Error Code: ${error?.code}. AlarmID: ${this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID)}`, "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) })), severityLevel: SeverityLevel.Critical });                            
                                        return;
                                    }
                                ////console.log("Reservation redirected", error);
                                ////console.log('reservationDetails', reservationDetails);
                                });
                        }
                }
                else{
                    ////console.log('reservationDetails:',"Reservation not possible");
                    this.Reservationerror=true;
                }
            }
            catch (e) {
                console.log('createConference error');
            }      
        }
    }
    
    //call back from elevator    
    callBackElevator(elevatorId?: any, uuid?: any, external?: any) {
        try {
            this.callbackError = null;
            this.AgentCancelled = false;
            ////this.riEnabled = callPriority == 0 ? true : false;
            this.callbackElevatorId = elevatorId;
            ////this.CCCElevatorCallBackPopUp(this.callbackElevatorId);
            if (this.callBackInline) { return; }
            this.isCallBackInitiated = true;
            this.callBackInline = true;
            this.AgentHanged = false;            
            this.callDispoDetails = {
                callDispositionId: "0",
                videoQuality: 0,
                audioQuality: 0,
                notes: ""
            };

            this.callMakeFalse();

            this.callBackElevatorIdField.hasError = false;

            if (elevatorId === undefined || elevatorId === null || elevatorId == "") {
                if (external == undefined) {
                    ////this.main.updateMessage = this.menuTranslation.callElevatorFieldEmptyError;
                    this.callBackInline = false;
                    return;
                }
                this.callBackElevatorIdField.hasError = true;
                this.callBackElevatorIdField.errorMsg = ('callElevatorFieldEmptyError');
                ////this.callBackElevatorIdField.next(this.callBackElevatorIdField)
                return;
            }
            ////this.callBackElevatorIdField.apiCalled = true;
            var sid = (this._localCookies.get(Constants.APPCOOKIES.CCC_SID) == null || this._localCookies.get(Constants.APPCOOKIES.CCC_SID) == "") ? this.ccAppSid : this._localCookies.get(Constants.APPCOOKIES.CCC_SID);
            ////this.autoDynamicWidth($rootScope.countryConfig.enableDataTracks, $scope.viewDetails);
            var callBackObj = {
                countryShortName: this._localDataService.ecd.selectedCountryShortName,
                elevatorId: elevatorId, uuid: uuid,
                sId: sid, command: Constants.G3MS_COMMANDS.joinRoomNew,
                mediaRegion: this._localDataService.ecd.currentUser.mediaRegion
            };
            this.callbackElevatorId = elevatorId;

            this.g3msService.callBackElevator(callBackObj).subscribe(
                {
                    next: (res: any) => {
                        this.callBackElevatorIdField.apiCalled = false;
                        this.callbackElevatorId = callBackObj.elevatorId;
                        this.callBackInline = false;
                        if (res.body.status) {
                            this.isAutoDialer = 0;
                            if (res.body.data.isAutoDialer) {
                                this.isAutoDialer = 1;
                            }
                            if (external == undefined) {
                                var callDetail = document.getElementById('call-back');
                                if (callDetail) {
                                    callDetail.style.display = "block";
                                }
                            }
                            //success then initiate all of them
                            ////this._dialog.closeAll();
                            this.callStartedSecs = 0;
                            this.menu.clicked = "";
                            this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "1");
                            this.toggleCallElevator(true);
                            this.controls = {
                                showMessage: false,
                                showStats: false
                            }
                            let identityName = DOMPurify.sanitize(this.identity.replace(/ /g,""));
                            var region = this._localDataService.ecd.currentUser.mediaRegion;
                            this._elevatorCallService.getIdentityToken({ identityName }).subscribe({
                                next: async (data: any) => {
                                    let deviceOptions: any = {                                        
                                        codecPreferences: ['opus', 'pcmu'],
                                        edge: region,
                                        //logLevel: 1,
                                        maxCallSignalingTimeoutMs: 30000,
                                        rtcConfiguration:{
                                            iceServers:data.body.servers,
                                        },
                                        enableIceRestart:true,
                                        audio: true, 
                                        enableRingingState: true,                                        
                                        allowIncomingWhileBusy: true,
                                        sounds: {
                                            incoming: false,
                                            outgoing: '',
                                            dtmf8: ''
                                        },
                                        tokenRefreshMs: 15000
                                    };
                                    ////this.token = data.body.token;
                                    this.updateActivity(Constants.APP_CONFIG.busySid);
                            var accepted = false;
                            let params = { From: 'client:' + this._localDataService.ecd.currentUser.userID, elevatorId: elevatorId, countryId: this._localDataService.ecd.currentUser.countryId };
                            ////let device = new Device(this.token,this.deviceOptions); 
                            if (this.device) {
                                this.device.destroy(); // clean old session
                                this.device = null;
                                } 
                            this.device = new Device(data.body.token);
                            this.device.updateOptions(deviceOptions); 
                                    let identityName = DOMPurify.sanitize(this.identity.replace(/ /g,""));
                                    this._elevatorCallService.getIdentityToken({ identityName }).subscribe({
                                        next: async (data) => {
                                            this.device.updateToken(data.body.token); 
                                        }
                                    }); 
                                    this.device.register(); 
            
                            this.device.on('tokenExpired', () => {                                
                                    this.Tokenrefresh();
                             });
                             this.device.on('tokenWillExpire',async () => {
                                this.Tokenrefresh();                    
                             });
                            this.call= null;
                            this.call =await this.device.connect({ params });                            
                            ////console.log('Out going call status',this.call);
                            
                            var ConnectionStatus = setInterval(()=>{
                                this.checkConnectionStatus1()},100000);
                            //Updated twilio token refresh code.
                            this.call.on("accept", (conn: any) => {
                                this.manualConnection=conn;
                                ////console.log('Outgoing Manualconnection',this.manualConnection);
                                var callDetail = document.getElementById('call-back');
                                if (callDetail) {
                                    callDetail.style.display = "block";
                                }
                                this._dialog.closeAll();
                                this._localDataService.ecd.callAccept = true;
                                this.home.isCollapse = true;
                                this.callCurrentStatus = 1;
                                let attribute: any = {};
                                attribute.mic_gain = "0";
                                attribute.speaker_volume = "0";
                                attribute.elevator_video_enabled = "false";
                                attribute.elevator_id = this.callbackElevatorId;
                                attribute.alarm_id = conn.parameters.CallSid;
                                attribute.isDBGenerated = false;
                                attribute.failure = null;

                                this.voiceCallType = 2
                                if (attribute.isDBGenerated) {
                                    this.voiceCallType = 3
                                }
                                this.callInitiator = Constants.APP_CONFIG.selfInitiator;
                                //this._dialog.closeAll();
                                this.initiateCallNotificationPopup(attribute, false, true);
                                this.callBackElevatorIdField.elevatorId = "";
                                this.manualConnection = conn;
                                accepted = true;
                                this.sendTone1(this.manualConnection);
                                this.keepAliveInterval = setInterval(()=>{
                                    ////console.log(this.manualConnection);
                                    this.sendTone1(this.manualConnection);
                                }, 30000);
                            });

                            this.call.on('ringing', (conn: any) => {
                                
                            });
                            this.call.on('disconnect', (conn: any) => {
                                if (this.AgentCancelled) {
                                    ////console.log('call cancelled');
                                    ////this.updateActivity(this.userStatus[0].sId);
                                    this.callBackElevatorIdField.elevatorId = "";
                                    this.callBackElevatorIdField.apiCalled = false;
                                    this._notificationService.showSnackBar('Unable to contact device at this time. Please try again');
                                }
                                else if (!accepted) {
                                    //alert('Elevator is busy.Try after sometime');
                                    this.callBackElevatorIdField.hasError = true;
                                    this.callBackElevatorIdField.errorMsg = "Unable to contact device at this time. Please try again";                                    
                                    alert("Call has been disconnected from REM. Click 'OK' in the popup and click 'Cancel' to close the Manual Call window");
                                    
                                    if (external != undefined) {
                                        
                                    }
                                    else {
                                        this.callBackElevatorIdField.errorMsg = "Unable to contact device at this time. Please try again";
                                        this.main.updateMessage = this.callBackElevatorIdField.errorMsg;
                                        this.main.showWarning = false;
                                    }

                                    //success then initiate all of them
                                    var callDetail = document.getElementById('call-back');
                                    if (callDetail != null) {
                                    }
                                    this.callBackInline = false;
                                    this.isCallBackInitiated = false;
                                    this.callBackElevatorIdField.elevatorId = "";
                                    this.callBackElevatorIdField.apiCalled = false;
                                }
                                else if (this.AgentHanged) {
                                    ////console.log("the call has ended by agent");
                                }
                                else {
                                    this.isCallDisconnected = 1;
                                    alert("Call disconnected from REM, to close the call details page click 'Save & hang up' button");
                                    var callDetail = document.getElementById('call-back');
                                    if (callDetail != null) {
                                        callDetail.style.display = "none";
                                    }
                                }
                                clearInterval(ConnectionStatus);                                
                                this.manualConnection = null;
                                this.phoneConnection = null;
                            });

                            this.call.on('error', (error: any) => {
                                if (!accepted) {
                                    this.callBackElevatorIdField.hasError = true;
                                    ////console.log("manual call test:",this.callBackElevatorIdField.errorMsg);
                                    alert("Call has been disconnected from REM. Click 'OK' in the popup and click 'Cancel' to close the Manual Call window");
                                    this.main.updateMessage = "";
                                    this.main.showWarning = false;
                                    this.callBackInline = false;
                                    this.isCallBackInitiated = false;
                                    this.callBackElevatorIdField.elevatorId = "";
                                    this.callBackElevatorIdField.apiCalled = false;
                                    this.callBackElevatorIdField.errorMsg = "Unable to contact device at this time. Please try again";
                                }
                            });
                                }
                            })
                            //Make agent Busy
                            
                        }
                        else {
                            this.callBackElevatorIdField.hasError = true;
                            if (external != undefined) {
                                this.main.updateMessage = "";
                            }
                            else {
                                this.main.updateMessage = this.callBackElevatorIdField.errorMsg;
                                this.main.showWarning = false;
                            }
                        }

                    }, error: (err: any) => {
                        this.callBackInline = false;
                        this.isCallBackInitiated = false;
                        //Show error & Make agent available
                        this.updateActivity(this.userStatus[0].sId);
                        this.callBackElevatorIdField.elevatorId = "";
                        this.callBackElevatorIdField.apiCalled = false;
                    }
                });
        }
        catch (e) {
            //Show error & Make agent available
            this.callBackInline = false;
            this.isCallBackInitiated = false;
            this.updateActivity(this.userStatus[0].sId);
            this.callBackElevatorIdField.apiCalled = false;
        }

    };

    DisconnectManualcall()
    {
        if(this.call && this.call.status() === 'open')
        {
            this.call.disconnect();
        }
        this.AgentCancelled = true;
    }
    toggleCallElevator(toggle: any, menu?: any) {
        this.callBackElevatorIdField = {};
        this.callBackElevatorIdField.elevatorId = this._localDataService.ecd.currentUser.elevatorId;
        this.menu.clicked = "";

        if (menu === 'callelevator') {
            this.menu.clicked = menu;

            this.togglesubmenu = false;
            this.toggle = !toggle;
            this.callBackElevatorIdField.elevatorId = this._localCookies.get(Constants.APPCONSTANTS.lastElevatorId);
        }
        // else if (menu === 'EndOfAlarm') {
        //     this.showClearTPA()
        // }
        // else if (menu === 'phonenumberSearch') {
        //     this.showHidePhonenumberSearch('block');
        // }
        else if (menu === 'settings' || menu === 'dashboard') {
            this.toggle = false;
            this.togglesubmenu = !this.togglesubmenu;
        }
        else if (menu === 'search') {
            this.togglesubmenu = false;
        }
        else {
            this.togglesubmenu = false;
            this.toggle = false;
        }
        this._localDataService.ecd.callAccept = false;
        this._localDataService.ecd.viewDetails = false;
    };
    updateActivity(activtiySid: any) {
        let sid = (this._localCookies.get(Constants.APPCOOKIES.CCC_SID) == null || this._localCookies.get(Constants.APPCOOKIES.CCC_SID) === "") ? this.ccAppSid : this._localCookies.get(Constants.APPCOOKIES.CCC_SID);
        ////console.log('updateActivity Resevation', activtiySid);
        this._authenticationService.updateActivity({ sId: sid, actSId: activtiySid },).subscribe({
            next: (res: any) => {
                if (res.status) {
                }
                else if (!res.status) {
                    this._authenticationService.updateActivity({ sId: sid, actSId: activtiySid },).subscribe({
                        next: (res: any) => {
                        }
                    });

                }
            },
            error: (err: any) => {
                //commonService.logException(err);
                ////console.log('updateexception', err);
            }
        });
    }
    
    callBack() {
        this.removeCookies();        
    }
    
    clearTransferValues() {
        this.user = { twilioAgentError: "" };
        //angular.element("#call-forward-modal")[0].style.display = 'none';
    }
    
    closeCallForwardModal() {
        //angular.element("#call-forward-modal")[0].style.display = 'none';
        this.clearTransferValues();
    };
    // When the user clicks on <span> (x), close the modal
    // Save and hangup for completing the call
    saveDispositionDetails(saveCall: any, popup?: any) {
        var protocol = window.location.protocol;
        var hostname = window.location.hostname;
        this.commonData.isInCallTimeout = false;
        this.isInCallTimeout = false;
        this.dispValidated = true;
        this.dispositionError = "";
        this.chooseQualityError = "";
        this.notesError = "";
        //saveCall.recAudio = this._localDataService.ecd.currentUser.recordAudio;
        //saveCall.dataRetension = this._localDataService.ecd.currentUser.days;
        saveCall.popup = true;
        saveCall.taskSid = this.taskSid;
        saveCall.uuid = this.uuid;
        //saveCall.isVVAppCall = this.isVVAppCall;
        //saveCall.agentVideoTransmitEnable = this.agentVideoTransmitEnable;
        saveCall.voiceCallType = this.voiceCallType;
        saveCall.callStartDateTime = this.callStartedDateTime;
        saveCall.callEndDateTime = this._commonService.getUTC("YYYY-MM-DDTHH:mm:ss") + "Z";
        saveCall.enableCallDispo = this._localDataService.ecd.countryConfig == null ? "true" : this._localDataService.ecd.countryConfig.enableCallDispo;
        saveCall.statusCallbackUrl = protocol + "//" + hostname + "/un-check/composition-webhook";
        saveCall.isElevatorDisconnected = this.call.isElevatorDisconnected;

        //Add exception saying if no video track added, elevator video is enabled
        if (this.noElevatorVideo == true && this.taskAttributes.elevator_video_enabled == 'false') {
            
        }

        let divVideo = document.querySelector('#remote-media > video');
        if (saveCall.callDispositionId == "0" && saveCall.enableCallDispo == 'true') {
            this.dispValidated = false;
            this.dispositionError = ('emptyCallDispositionErrMsg');
        }
        ////&& this.video.auto
        if ((saveCall.videoQuality == 0 && saveCall.enableCallDispo == 'true'  && !(this.isCallBackInitiated && divVideo == null)) || (saveCall.audioQuality == 0 && saveCall.enableCallDispo == 'true')) {
            this.dispValidated = false;
            this.chooseQualityError = ('emptyQualityErrMsg');
        }

        // // if (!this.dispValidated) {
        // //     return;
        // // }
        this.AgentHanged = true;
        ///console.log('phoneConnection', this.phoneConnection);
        AppConfigService.trackEvent('twilio', { name: "saveDispositionDetails" }, this.phoneConnection);
        clearInterval(this.keepAliveInterval);        
        if (this.phoneConnection != null) {            
            clearInterval(this.keepAliveInterval);            
            if (this.isAutoDialer == 1) {
                setTimeout(() => { this.phoneConnection.sendDigits("*") }, 1500);
                setTimeout(() => { this.phoneConnection.sendDigits("#") }, 2000);
                setTimeout(() => { this.phoneConnection.sendDigits("0") }, 2500);
            }
            else {      
                var i =0;      
                setTimeout(() => { this.phoneConnection.sendDigits("*")}, 1500);                
                setTimeout(() => { this.phoneConnection.sendDigits("0")}, 2000);                
                setTimeout(() => { this.phoneConnection.sendDigits("#")}, 2500);                
                setTimeout(() => { this.phoneConnection.sendDigits("*")}, 3000);                
                setTimeout(() => { this.phoneConnection.sendDigits("0")}, 3500);                
                setTimeout(() => { this.phoneConnection.sendDigits("#")}, 4000);            
            }
            setTimeout(() => { this.phoneConnection?.disconnect();
                ////console.log('devicephoneConnection:disconnect')
            }, 4500);            
        }
        if (this.manualConnection != null) {
            clearInterval(this.keepAliveInterval);            
            if (this.isAutoDialer == 1) {
                setTimeout(() => { this.manualConnection.sendDigits("*") }, 1500);
                setTimeout(() => { this.manualConnection.sendDigits("#") }, 2000);
                setTimeout(() => { this.manualConnection.sendDigits("0") }, 2500);
            }
            else {
                setTimeout(() => { this.manualConnection?.sendDigits("*") }, 1500);
                setTimeout(() => { this.manualConnection?.sendDigits("0") }, 2000);
                setTimeout(() => { this.manualConnection?.sendDigits("#") }, 2500);
                setTimeout(() => { this.manualConnection?.sendDigits("*") }, 3000);
                setTimeout(() => { this.manualConnection?.sendDigits("0") }, 3500);
                setTimeout(() => { this.manualConnection?.sendDigits("#") }, 4000);
            }
            setTimeout(() => { this.manualConnection?.disconnect() }, 4500);
        }

        //$('.cl-message').removeAttr('style');
        this._notificationService.showSnackBar('call Getting Saved');
        var callDisposition = '';
        var dispoCodeItem = this.callDispstnArry.filter((item: any) => {
            return item.callDispositionId == saveCall.callDispositionId;
        });

        if (dispoCodeItem.length > 0) {
            saveCall.dispositionCode = dispoCodeItem[0].code;
            saveCall.RepeatedTPACalls = dispoCodeItem[0].RepeatedTPACalls;
            callDisposition = dispoCodeItem[0].callDisposition;
        }
        setTimeout(() => {
            if (popup == null) {
                this._notificationService.showSnackBar('call Updating');
                saveCall.popup = false;
                this.callHanged = true;
                window.callHanged = true;
                ////this.elevatorChat = { messages: [] };
                if (this.cancelUserTimeout != undefined) {
                    clearInterval(this.cancelUserTimeout);
                    this.cancelUserTimeout = undefined;
                }

                //validate all the save call disposition details here
                this.callOver = true;
                this._localDataService.ecd.callAccept = false;
                if (this.cancelUserTimeout != undefined) {
                    clearInterval(this.cancelUserTimeout);
                    this.cancelUserTimeout = undefined;
                }
                saveCall.alarmId = this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID);
                saveCall.callDetailsId = this.callDetailsId;
            }
            else {
                saveCall.previousValue = 'Call disposition: ' + this.callItem4Edit.callDisposition + ', Video Quality: ' + this.callItem4Edit.videoQuality + ', Audio Quality: ' + this.callItem4Edit.audioQuality + '& Notes: ' + this.callItem4Edit.notes;
                saveCall.newValue = 'Call disposition: ' + callDisposition + ', Video Quality: ' + saveCall.videoQuality + ', Audio Quality: ' + saveCall.audioQuality + '& Notes: ' + saveCall.notes;
                saveCall.alarmId = this.callItem4Edit.alarmId;
            }

            saveCall.localParticipantSid = this.participantSid == null ? 0 : this.participantSid;
            saveCall.remoteParticipantSid = this.remoteParticipantSid == null ? 0 : this.remoteParticipantSid;
            saveCall.isCallDisconnected = this.isCallDisconnected;
            ////saveCall.roomSid = this.roomSid == null ? 0 : this.roomSid;
            saveCall.roomSid = '';
            saveCall.alarmId = this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID);
            saveCall.elevatorId = this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID);
            saveCall.initiator = this.callInitiator;
            this.dataTrackAdded = false;
            this.audioTrackAdded = false;
            this.callCurrentStatus = 0;
            saveCall.videoQuality=0;
            saveCall.twilioResVideoUrl='NULL';
            saveCall.twilioResAudioUrl='NULL';
            saveCall.videoSid='NULL';
            saveCall.audioSid='NULL';
            ////this.localVideoTrack?.stop();
            ////this.localAudioTrack?.stop();
            //To stop icon displayed on the tab
            /////this.stopMediaTracks(this.localStreamTracks);
            ////this.remoteTrack = null; 
            if(saveCall.initiator=="Agent")
            {
                saveCall.callDispositionId=0;
            }

            saveCall.notes = DOMPurify.sanitize(saveCall.notes);
            // if (this.framRateInterval != null) {
            //     clearInterval(this.framRateInterval);
            // }
            this._elevatorCallService.saveDispositionDetails(saveCall).subscribe({
                next: (res: any) => {
                    //Clearing the calldetails
                    this.clearCallDetails();                   

                    this.elevatorCarId = '';
                    if (popup == null) {
                        /////////////this.leaveRoomIfJoined(null, false);
                        if (this.isCallBackInitiated && this.agent.onCallbackStatus == 'Offline'
                            && this._localDataService.ecd.currentUser.roleId == 2) {
                            saveCall.activityId = this.userStatus[3].activityId;
                        }
                        else {
                            saveCall.activityId = this.userStatus[0].activityId;
                        }
                    }                   

                    //Update the activity back to Idle
                    this.closeCallForEdit();
                    this._notificationService.showSnackBar('call Saved');
                    if (popup == null) {
                        if (this._localDataService.ecd.currentUser.isAgent != 0) {

                            // If the Agent was on 'Not Avaialble' when initiating callback from Elevator.
                            // Application cannot change his status to Available after completing the call.
                            if (this.isCallBackInitiated && this.agent.onCallbackStatus == 'Offline') {
                                this.updateForSaveDisp(this.userStatus[3].sId);
                            }
                            else {
                                this.updateForSaveDisp(this.userStatus[0].sId);
                            }
                        }
                        this._localCookies.delete(Constants.APPCOOKIES.CCC_ELEVATORID);
                        this._localCookies.delete(Constants.APPCOOKIES.CCC_INCIDENTID);
                        this._localCookies.delete(Constants.APPCOOKIES.CCC_ALARMID);
                    }
                    else {
                        var callDisp = this.callDispstnArry.filter((disp: any) => {
                            return disp.callDispositionId == saveCall.callDispositionId;
                        });
                        if (callDisp.length > 0) {
                            saveCall.callDisposition = callDisp[0].callDisposition;
                        }
                        this.openCallDetails(this.callItem4Edit.alarmId, this.callItem4Edit.incidentId);
                        //$scope.callItem4Edit = saveCall;
                        //$scope.updateCallElevatorDetail($scope.callItem4Edit);
                    }
                    this.isCallBackInitiated = false;
                    //TODO
                    //$scope.$emit('callEvents', 'savedisp');
                    if (this.syncClient) {
                        this.syncClient.document('CallEvent-' + this._localDataService.ecd.currentUser.countryConfigurationId).then((doc: any) => {
                            doc.update({ 'callEvent': 'savedisp' });
                        });
                    }
                    this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, '0');
                    // // this.roomName = '';
                    // // this.elevatorId = '';
                    this.clearElevatorDetails();
                    this.router.navigate(['/dashboard']);
                },
                error: (err: any) => {
                    this.leaveRoomIfJoined(null, false);
                    ////this.roomName = '';
                    ////this.elevatorId = '';
                    //$scope.$emit('callEvents', 'savedisp");
                    this.clearElevatorDetails();

                    //Update Agent's status as available for next call evnthough save call disposition API failed.
                    this.clearCallDetails();
                    if (this._localDataService.ecd.currentUser.isAgent != 0) {

                    // If the Agent was on "Not Avaialble" when initiating callback from Elevator.
                    // Application cannot change his status to Available after completing the call.
                    if (this.isCallBackInitiated && this.agent.onCallbackStatus == "Offline") {
                        this.updateForSaveDisp(this.userStatus[3].sId);
                    }
                    else {
                        this.updateForSaveDisp(this.userStatus[0].sId);
                    }
                    }
                    if (this.syncClient) {
                    this.syncClient.document('CallEvent-' + this._localDataService.ecd.currentUser.countryConfigurationId).then((doc: any) => {
                        doc.update({ "callEvent": "savedisp" });
                    });
                    }

                    this._router.navigate(['/dashboard']);
                }

            });
        }, 9500);
        ////window.location.reload();
            if(this.Reservationerror===true) {
            this.agent.selectedStatus = "Idle";            
            this.agentStatusEmit.next({
                selectedStatus: this.agent.selectedStatus,
                prevSelStatus: this.agent.prevSelStatus,
                onCallbackStatus: this.agent.onCallbackStatus
            });
        }                
    };

    clearElevatorDetails() {
        this._localCookies.delete(Constants.APPCOOKIES.CCC_ELEVATORID);
        this._localCookies.delete(Constants.APPCOOKIES.CCC_INCIDENTID);
        this._localCookies.delete(Constants.APPCOOKIES.CCC_ALARMID);
        this._localCookies.delete(Constants.APPCONSTANTS.lastElevatorId);
        this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "0");
        this.elevatorId = "";
        this.displayElevatorId = "";
        this.call.displayElevatorId = "";
        this.roomName = "";
        this.callbackElevatorId = "";
        this.callBackElevatorIdField.elevatorId = "";
      }
    openCallDetails(alarmId: any, incidentId: any) {
        try {
            //Clear before opening with new calldetails
            this.clearCallDetails();            
            this.home.selected = 0;
            this.incidentDetailsList = [];
            this.homecontroller = {
                g3msResult: []
            };
            this.callMakeFalse();
            this.home.currentPage = 0;
            this.callTimings = 0;
            this.dispValidated = true;
            this.dispositionError = "";
            this.chooseQualityError = "";
            this.notesError = "";
            ////this.elevatorInfoStatus = "";

            this.callDispoDetails = {
                callDispositionId: "0",
                videoQuality: 0,
                audioQuality: 0,
                notes: ""
            };
            this.starArray = [1, 2, 3, 4, 5];
            this._localDataService.ecd.viewDetails = true;
            this._localDataService.ecd.callAccept = true;
            this.home.isCollapse = true;
            this.home.isChatCollapse = true;
            this.dataLoading = true;
            //autoDynamicWidth($rootScope.countryConfig.enableDataTracks, $rootScope.viewDetails);
            //autoDynamicWidth(false, this._localDataService.ecd.viewDetails);
            this.tpr = {
                status: ('loading...'),
                displayStatus: true,
                labelStatus: true
            };
            this._elevatorCallService.getCallsDetailsElevator(alarmId).subscribe({
                next: (res: any) => {
                    this.dataLoading = false;
                    this.incidentDetailsList = res.data.recordsets[0];
                    this.callDetailsList = res.data.recordsets[1];
                    this.messageDetailsList = res.data.recordsets[2];

                    let callDetailsRecords: any = {};
                    if (incidentId != null) {
                        var data = this.incidentDetailsList.filter((ele: any) => {
                            return ele.incidentId == incidentId;
                        });

                        if (data.length > 0) {
                            callDetailsRecords = data[0];
                        }
                    }
                    else {
                        callDetailsRecords = this.incidentDetailsList[0];
                    }
                    //No Need below methos for R2C
                    /*
                    this._elevatorCallService.getTPAStatus({ countryShortName: this._localDataService.ecd.currentUser.countryShortName, elevatorId: callDetailsRecords.displayElevatorId }).subscribe({
                        next: (res: any) => {
                            this.tpr = {
                                status: ('cleared'),
                                displayStatus: true,
                                labelStatus: false
                            }
                            if (res.data != null) {
                                if (res.data.tpa_status != null) {
                                    if (res.data.tpa_status.rsp == 1) {
                                        //Enable reset button
                                        this.tpr = {
                                            status: ('open'),
                                            displayStatus: false,
                                            labelStatus: true
                                        }
                                    }
                                }
                            }
                        }
                    });*/

                    try {
                        if (this.incidentDetailsList[0].message !== "" && this.incidentDetailsList[0].message != null) {

                            //All the messages, time of sent/ received and sender will be concatenated to one string. Here, it will be split to display.
                            this.incidentDetailsList[0].message = this.incidentDetailsList[0].message.split('+-+');
                        }
                    }
                    catch (e) { }

                    this.getWorkerCallActivity({ alarmId: alarmId, incidentId: callDetailsRecords.incidentId });

                    // // if (callDetailsRecords.buildingAddress == "" || callDetailsRecords.buildingAddress == null) {
                    // //     var address = this._commonService.addressBuilder("", callDetailsRecords.address2);
                    // //     address = this._commonService.addressBuilder(address, callDetailsRecords.countryName);
                    // //     address = this._commonService.addressBuilder(address, callDetailsRecords.postalCode);
                    // //     callDetailsRecords.buildingAddress = callDetailsRecords.address1 + ",</br>" + address;
                    // // }

                    //Elevator details
                    this.homecontroller = {
                        g3msResult: {
                            contractInfo: {
                                controllerType: callDetailsRecords.controllerType,
                                buildingName: callDetailsRecords.buildingName,
                                floorName: callDetailsRecords.floorName,
                                buildingAddress: callDetailsRecords.buildingAddress,
                                branchName: callDetailsRecords.branchName,
                                buildingNotes: callDetailsRecords.buildingNotes,
                                unitNotes: callDetailsRecords.unitNotes,
                                note: callDetailsRecords.unitNotes,                                
                                postalCode: callDetailsRecords.postalCode,
                                latitude: callDetailsRecords.latitude,
                                longitude: callDetailsRecords.longitude,
                                contractInformation: callDetailsRecords.contractInformation,
                                contractStatus: callDetailsRecords.contractStatus,
                                customerName: callDetailsRecords.customerName,
                                otisBranch: callDetailsRecords.otisBranch,
                                commissioningMode: callDetailsRecords.commissioningMode,
                                failure: callDetailsRecords.failure,
                                isFailedCall: callDetailsRecords.isFailedCall,
                                Callstatus: callDetailsRecords.Callstatus,
                                unitState: callDetailsRecords.unitState
                            },
                            callDetails: callDetailsRecords,

                        }
                    };

                    //$rootScope.$broadcast("loadMap", callDetailsRecords);
                    //this.numOfPages = Math.ceil(this.incidentDetailsList.length / this.pageSize);
                }, error: (err: any) => {
                    this.dataLoading = false;
                }
            });
        }
        catch (e) {
            this.dataLoading = false;
        }
    }
    getWorkerCallActivity(payload: any) {
        this._elevatorCallService.getWorkerCallActivities(payload).subscribe({
            next: (result: any) => {
                if (result.body.status) {
                    this.workerCallHistory = result.body.data.recordset;
                } else if (result.status != 200) {
                    //commonService.logException(err);
                    //this._notificationService.errorMessage("Something went wrong", "Error")
                }
            }
        });
    }
    // setupAudioCall Method
    setupAudioCall() {
        this.AgentHanged = false;
        ////let currentsysdatenow = new Date();
        ////console.log('setupAudioCall:',currentsysdatenow); 
        let identityName = DOMPurify.sanitize(this.identity.replace(/ /g,""));
        var region = this._localDataService.ecd.currentUser.mediaRegion;
        ////console.log('Identity:',this.identity)
        //this._elevatorCallService.getVoiceIdentityToken({ identityName }).subscribe({
        this._elevatorCallService.getIdentityToken({ identityName}).subscribe({
            next:async (data:any) => {
                let deviceOptions: any = {                    
                    codecPreferences: ['opus', 'pcmu'],
                    ////preferredAudioCodecs: ['opus', 'pcmu'],
                    edge: region,
                    ////logLevel: 1,
                    rtcConfiguration:{
                        iceServers:data.body.servers,
                    },
                    enableRingingState: true,
                    maxCallSignalingTimeoutMs:30000,
                    enableIceRestart:true,
                    audio: true, 
                    allowIncomingWhileBusy: true,
                    sounds: {
                        incoming: false,
                        outgoing: '',
                        dtmf8: ''
                    },
                    tokenRefreshMs: 15000,
                }; 
                if (this.device) {
                this.device.destroy(); // clean old session
                this.device = null;
                }  
                this.device = new Device(data.body.token);
                this.device.updateOptions(deviceOptions);
                //let currentsysdatenow = new Date();
                //console.log('Device register Date:',currentsysdatenow);
                this.device.register(); 

                this.device.on('registered', () => {
                    ////console.log('device registerd')
                });

                this.device.on('connect', (_call: any) => {                    
                    this.AgentHanged = false;
                    this.callConnected = true;
                    ////console.log("connected to conference");
                });

                this.device.on('ready', (device: any) => {                    
                    ////console.log("Twilio Client Device is ready");
                });                
                this.device.on('incoming', (_call: Call) => {
                    _call.on('accept', () => {                        
                        this.phoneConnection = _call;
                        this.sendTone(this.phoneConnection);
                        this.callOver = false;
                        ////this.callCurrentStatus = 2;
                         this.callHanged = false;
                        window.callHanged = false;
                        
                        this._elevatorCallService.updateCall({
                            incidentId: this._localCookies.get(Constants.APPCOOKIES.CCC_INCIDENTID),
                            alarmId: this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID),
                            isCallConnected: 'true',
                            uniqueId: this._localDataService.ecd.callUniqueId
                        }).subscribe();
                    });
                    _call.on('cancel', () => {
                        this.phoneConnection = null;
                        alert("Call disconnected from REM, to close the call details page click 'Save & hang up' button");
                    });

                    _call.on('disconnect', (_call: any) => {
                        if (_call._direction != 'OUTGOING' && this.AgentHanged==false) {
                            this.isCallDisconnected = 1;
                            this.callOver = true;
                            this.callHanged = true;
                            window.callHanged = true;

                            //Cancel clock ticking
                            if (this.cancelUserTimeout != undefined) {
                                clearInterval(this.cancelUserTimeout);
                                this.cancelUserTimeout = undefined;
                            }
                             alert("Call disconnected from REM, to close the call details page click 'Save & hang up' button");
                            
                        }
                        // // else 
                        // //     {  
                        // //     //// _call.disconnect();
                        // //     ////alert("Call disconnected from REM, to close the call details page click 'Save & hang up' button");
                           
                        // // }
                        _call.disconnect();
                    });
                    _call.accept();                    
                });

                this.device.on('disconnect', (_call: any) => {
                    if (_call._direction != 'OUTGOING' && !this.AgentHanged) {
                        this.isCallDisconnected = 1;
                        alert("Call disconnected from REM2, to close the call details page click 'Save & hang up' button");
                    }
                    else {                        
                        ////console.log("Disconnected the conference");
                    }
                    this.manualConnection = null;
                    this.phoneConnection = null;
                    _call.disconnectAll();
                });

                this.device.on('error', (twilioError:any, _call:any) => {                   
                    ////console.log('An error has occurred: ', twilioError);
                    if (twilioError.code >= 0) {
                        ////console.log('New Device register: ' + twilioError.code,twilioError);                        
                        ////let currentsysdatenow = new Date();
                        ////console.log('twilioError occured:',currentsysdatenow);                        
                        ////this.setupAudioCall();                                               
                    }                     
                                             
                });

                this.device.on('offline', (device: any) => { 
                    device.disconnectAll(); 
                    ////console.log('Device offline');                  
                    this.setupAudioCall();
                });
                
                this.device.on('tokenWillExpire',async () => {
                    ////let currentsysdatenow = new Date();
                    ////console.log('tokenWillExpire occured:',currentsysdatenow);
                    this.Tokenrefresh();                    
                });
                this.device.on('tokenExpired',async () => {
                    ////let currentsysdatenow = new Date();
                    ////console.log('tokenExpired occured:',currentsysdatenow);
                    this.Tokenrefresh();
                    });                
                this.device.on('unregistered', (device: any) => {
                    ////device.unregister();
                    ////this.device.destroy();   
                    ////console.log('Device  is unregistered:',device);
                });
            }, 
            error: (err:any) => {
                this.setupAudioCall();                   
                this.isCallBackInitiated = false;
                ////console.log("Generating identity token error",err);                
            }
        });
    }
    /*
    Token Refresh
    */
    Tokenrefresh()
    {
                 let identityName = DOMPurify.sanitize(this.identity.replace(/ /g,""));
                        this._elevatorCallService.getIdentityToken({ identityName }).subscribe({
                            next: async (data) => {
                                ////console.log('Device Token23:',data.body.token);
                                this.device?.updateToken(data.body.token);
                            }                                 
                        });
    }    
    /*
    incoming call popup code
    */
    incomingCallPopup(data?: any): void {        
        const dialogConfig = new MatDialogConfig();
        let callData = {
            notifiTimeLeft: this.notifiTimeLeft,
            displayElevatorId: this.elevatorId,
            failurCode: this.failureReasonCode,
            alarmId: data.alarmId,
            remGroupId: data.remGroupId,
            countryId: data.countryId,
            callerId: data.callerId,
            status: true,
            ...this.changeStatusConfrmModel
        }
        ////console.log('Calldata:', callData);
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '600px';
        dialogConfig.height = '500px';
        dialogConfig.data = callData;

        //const dialogRef = this._dialog.open(IncomingCallComponent, dialogConfig);
        this.incomingCallDialogRef = this._dialog.open(IncomingCallComponent, dialogConfig);
    }
    deleteItemFromMap(elevatorId: any) {
        this.syncClient.map(Constants.APP_CONFIG.taskQueueKey + this.queueCountry).then((map: any) => {
            map.remove(elevatorId).then(() => {
                this.getItemFromMap();
            }, () => {
                this.getItemFromMap();
            });
        });
    };

    accceptTask(acceptCallBack: any) {
        this._commonService.logMessage({ "methodName": "AcceptTheCall", "elevatorId": this.elevatorId, "extraDetails": " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), "message": "acceptTheCallStarted", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
        this.callCurrentStatus = 1;
        this.callStartedSecs = 0;
        this.commonData.isInCallTimeout = false;
        this.isInCallTimeout = false;
        this.callStatusModal.next({ 'display': 'block' });
        this.callStartedDateTime = this._commonService.getUTC("YYYY-MM-DDTHH:mm:ss") + "Z";        
        this._localDataService.ecd.statusId = 6;
        this.callOver = false;
        acceptCallBack(true);
        if (this.currentReservation && false && this.taskAttributes.call_from == null) {
            this.currentReservation.accept()
                .then((acceptedReservation: any, error: any) => {
                    if (error) {
                        this._commonService.logException({ "methodName": "AcceptTheCall.currentReservation.accept", "exceptionDetails": "Error: " + error.message + " AlarmID: " + this._localCookies.get('CCApp-alarmID'), "alarmId": this._localCookies.get('CCApp-alarmID') });
                        this._commonService.logMessage({ "methodName": "AcceptTheCall.currentReservation.accept", "elevatorId": this.elevatorId, "extraDetails": "Error: " + error.message + " AlarmID: " + this._localCookies.get('CCApp-alarmID'), "message": "reservationAcceptException", "alarmId": this._localCookies.get('CCApp-alarmID') });
                        //Accepting the task error, check is it assigned to some one else
                        acceptCallBack(false);
                    }
                    else {
                        this.callCurrentStatus = 1;
                        this.callStartedSecs = 0;
                        this.isInCallTimeout = false;
                        this.callStatusModal.next({ 'display': 'block' })
                        this.callStartedDateTime = this._commonService.getUTC("YYYY-MM-DDTHH:mm:ss") + "Z";
                        this.updateWorkerActivityTwilio(this.userStatus[2].sId);
                        this._commonService.logMessage({ "methodName": "AcceptTheCall.currentReservation.accept", "elevatorId": this.elevatorId, "extraDetails": " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), "message": "acceptTheCallAccepted", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        this._localDataService.ecd.statusId = 6;
                        this.callOver = false;
                        acceptCallBack(true);
                    }
                })
                .catch((error: any) => {
                    this._commonService.logException({ "methodName": "AcceptTheCall.currentReservation.accept", "exceptionDetails": "Error: " + error.message + " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                    this._commonService.logMessage({ "methodName": "AcceptTheCall.currentReservation.accept", "elevatorId": this.elevatorId, "extraDetails": "Error: " + error.message + " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), "message": "reservationAcceptException", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                    //Accepting the task error, check is it assigned to some one else
                    acceptCallBack(false);
                    //      console.log(`Error: ${error}`);
                });
        }
    }

    /*
    * Method to get CCC call detayls by alarmId
    * alarmid: AlarmId of the call which will be generated by CPIB.
    */
    getCallDetails(alarmId?: any) {        
        let payload: any = {};
        payload.elevatorId=alarmId == null ? this._localCookies.get('CCApp-alarmID') : alarmId;
        this._elevatorCallService.getCallsDetailsElevator(payload).subscribe({
            next: (res: any) => {
                this.incidentDetailsList = res.body.data.recordsets[0];
                this.callDetailsList = res.body.data.recordsets[1];
                this.messageDetailsList = res.body.data.recordsets[2];
                let callDetailsId = this.incidentDetailsList.callDetailsId;
                let numberOfCalls = 0;
                let secondsAgo = 0;
                ////this.incidentDetailsList[0].secsAgoText = "";
                this.messageDetailsList = res.body.data.recordsets[2];

                try {
                    //if(this.incidentDetailsList[0].secsAgo != null) {
                    //  this.incidentDetailsList[0].secsAgoText = toHoursAndMinutes(this.incidentDetailsList[0].secsAgo);
                    //}
                    if (this.incidentDetailsList[0].message !== "" && this.incidentDetailsList[0].message != null) {
                        //All the messages, time of sent/ received and sender will be concatenated to one string. Here, it will be split to display.
                        this.incidentDetailsList[0].message = this.incidentDetailsList[0].message.split('+-+');
                    }
                }
                catch (e) { }
                this.homecontroller.g3msResult.callDetails = this.incidentDetailsList[0];
                this.callDetails.next({ g3msResult: this.homecontroller.g3msResult, incidentDetailsList: this.incidentDetailsList, home: this.home, countryConfig: this._localDataService.ecd.countryConfig });

                if (alarmId == null) {
                    //Update the call as accepted
                    this._elevatorCallService.updateCall({
                        incidentId: this._localCookies.get(Constants.APPCOOKIES.CCC_INCIDENTID),
                        alarmId: (alarmId == null ? this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) : alarmId),
                        uniqueId: this._localDataService.ecd.callUniqueId
                    }).subscribe({
                        next: (res: any) => {
                            if (res.body.status) {
                                //callStartedDateTime = updateRes.data.startedDateTime;
                            }
                        }
                    });
                }
            },
            error: (error: any) => {

            }
        });

    };
    toHoursAndMinutes(totalSeconds: any) {
        const totalMinutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        var totalTime = "";

        if (hours > 0) {
            totalTime = hours + ` ${('hours')} `;
            // if (hours > 9) {
            //     totalTime = hours + ` ${('hours')} `;
            // } else {
            //     totalTime = hours + ` ${('hour')} `;
            // }
        }

        if (minutes > 0) {
            totalTime += minutes + ` ${('mins')} `;
            // if (minutes > 9) {
            //     totalTime += minutes + ` ${('mins')} `;
            // } else {
            //     totalTime += minutes + ` ${('min')} `;
            // }
        }

        if (seconds > 0) {
            totalTime += seconds + ` ${('secs')}`;
            // if (seconds > 9) {
            //     totalTime += seconds + ` ${('secs')}`;
            // } else {
            //     totalTime += seconds + ` ${('secs')}`;
            // }
        }

        return totalTime;
    }

    logBytes(kind: string, type: string, bytes: any) {
        var details = bytes + " of " + kind + " bytes " + type;
        this._commonService.logMessage({ methodName: "bytes.exchanged", userDefined: true, extraDetails: details, elevatorId: this.elevatorId, message: "", "alarmId": this._localCookies.get('CCApp-alarmID') });
    }
    
    muteAudio() {
        this.activeRoom.localParticipant.audioTracks.forEach((value: any) => {
            if (value.track.isEnabled) {
                value.track.disable()
                // $(".local-media audio").hide();
            } else {
                value.track.enable();
                //  $(".local-media audio").show();
            }
        });
    };
    
    // handleMediaError(error: any) {
    //     console.error('Failed to acquire media:', error.name, error.message);
    //     //commonService.logException({ "methodName": "handleMediaError:" + error.name, "exceptionDetails": error.message + ($cookies.get('CCApp-alarmID') != null ? " AlarmID: " + $cookies.get('CCApp-alarmID') : ""), "elevatorId": $cookies.get('CCApp_elevatorID') });
    // }
    /**
 * To check the user's browser for support of audio & video devices
 */
    deviceCheck() {
        //Browser support media devices.
        if (navigator.mediaDevices) {
            navigator.mediaDevices.enumerateDevices().then((devices: any) => {

                //Getting video input
                let videoInput = devices.find((device: any) => {
                    if (device.kind === Constants.APP_CONFIG.videoinput) {
                        return device;
                    }
                });

                //Getting audio input
                let audioInput = devices.find((device: any) => {
                    if (device.kind === Constants.APP_CONFIG.audioinput) {
                        return device;
                    }
                });

                //To check by default, whether Agent support is only for Audio or both.
                let res = 0;
                if (Constants.APP_CONFIG.isOnlyAudio) {
                    res = (audioInput != null ? -1 : 0);
                }
                else {
                    res = videoInput == null && audioInput == null ? 2 : (videoInput != null && audioInput != null ? -1 : (audioInput == null ? 0 : 1));
                }

                //Based on the Agent vidoe configuration, appropiriate message will be displayed.
                switch (res) {
                    case 0:
                        //Agent is configured for video & audio. However, console is detecting only video devices.
                        this.message();
                        this.main.noAudioDevice = true;
                        this.main.noVideoDevice = null;
                        this.main.noDevices = null;
                        break;
                    case 1:
                        //Agent is configured for video & audio. However, console is detecting only audio devices.
                        if (!this.noCameraAvailable) {
                            this.deviceCheckCalled = false;
                        }
                        this.noCameraAvailable = true;
                        this.message();
                        this.main.noAudioDevice = null;
                        this.main.noVideoDevice = true;
                        this.main.noDevices = null;
                        break;
                    case 2:
                        //Agent is configured for video & audio. However, console is detecting no audio & video devices.
                        this.noCameraAvailable = false;
                        this.message();
                        this.main.noAudioDevice = null;
                        this.main.noVideoDevice = null;
                        this.main.noDevices = true;
                        break;
                    default:
                        //Agent is not configured for video & audio.
                        this.main.showWarning = false;
                        this.main.updateMessage = "";

                        if (this.noCameraAvailable) {
                            if (videoInput != null) {
                                this.noCameraAvailable = false;
                            }
                            this.deviceCheckCalled = false;
                            //$(".cl-activity").removeAttr("style");
                            this.message();
                        }
                        break;
                }
            });
        }
    }
    //To assign and display messages.
    message() {
        if (!this.deviceCheckCalled) {
            this.main.transferMessage = "";
            this.main.updateMessage = null;
            this.main.showWarning = true;
            this.deviceCheckCalled = true;
            //commonService.showStatusMessage('cl-activity', Constants.APP_CONFIG.deviceCheckTimeout + 10000);
        }
    };    
    
    completeAssignedTask() {
        if (this.worker != null) {
          this.worker.reservations.forEach((reserv: any) => {
            // //  if (reserv.status == "pending") {
            // //     this.handleReservation(reserv);
            // //   }
            if (reserv.status == "accepted") {
              //complete reservation
              reserv.task.complete(reserv.task.sid);
            }
          });
        }
    }
    leaveRoomIfJoined(callback: any, isLoad: any) {
        try {                      
                //Completing the current task
                if (this.currentReservation) {
                    this._commonService.logMessage({ "methodName": "leaveRoomIfJoined", "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "message": "completingTaskInitiated", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                    //Make assigned task as complete
                    this.completeAssignedTask();
                } else {
                    //Callback function and check for null
                    if (callback) {
                        callback();
                        return;
                    }
                }
            }
          catch (e: any) {
            //If there is exception, when disconnecting room
            this._commonService.logException({ "methodName": "leaveRoomIfJoined", "exceptionDetails": e.message, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
            //Callback function and check for null
            if (callback) {
                callback();
                return;
            }
        }
    }    
    // Detach given track from the DOM.
    detachTrack(track: any) {
        if (track.detach) {
            track.detach().forEach((element: any) => {
                element.remove();
                element.srcObject = null;
            });
        }
    }
    // A RemoteTrack was unpublished from the Room.
    trackUnpublished(publication: any) {
        //log(publication.kind + ' track was unpublished.');
    }

    //Worker object end  
     
    clearCallDetails() {
        //Clearing the calldetails
        this.homecontroller = { g3msResult: { contractInfo: {}, callDetails: {} } };
        this.incidentDetailsList = [];
        ///////this.workerCallHistory = [];
        this.resetCallDisposition();
    }
    resetCallDisposition() {
        this.callDispoDetails = {
            callDispositionId: "0",
            videoQuality: 0,
            audioQuality: 0,
            notes: ""
        };
    }
    updateWorkerActivityTwilio(activitSid: any) {
        if (this.worker) {
            this.worker.activities.forEach((activity: any) => {
                ////console.log('Reason2', activity.sid);
                ////console.log('Reason3', activitSid);
                ////console.log('Reason4', this.worker.activity.name);
                if (activity.sid == activitSid) {                    
                    activity.setAsCurrent().then(() => {
                        ////console.log('Reason1', this.worker.activity.name);
                    });
                }
            });
        }
    }
    /*
       To update userIdentity sync client for supervisor dashboard activities
   */
    updateSyncClient(userId: any, name: any, status: any, statusId: any) {
        ////, callType: any
        this.syncClient.map('UserIdentity' + this._localDataService.ecd.currentUser.countryConfigurationId).then((map: any) => {
            ////17112024
            ////map.update("UserId" + userId, { "name": name, "status": status, "statusId": statusId, "callType": callType, "datetime": this.callStartedDateTime = this._commonService.getUTC() });
            map.update("UserId" + userId, { "name": name, "status": status, "statusId": statusId});
            ////, "callType": callType
            ////,"datetime": this.callStartedDateTime = this._commonService.getUTC("YYYY-MM-DDTHH:mm:ss")+ "Z"
        });
    }
    insertClientAvailable(data: any) {
        ////this.startClientAvailable();
        this.startClientAvailable({ data: data, syncClient: this.syncClient });
        this.pingServerCancelTimeout = setInterval(this.startClientAvailable.bind(this), 120000);
    }
    //startClientAvailable(data: any)
    startClientAvailable(data: any) {
        this.syncTimerCount = this.syncTimerCount + 1;
        this.syncClient.map(Constants.APP_CONFIG.serverBeatKey).then((map: any) => {
            //get UTC datetime & assign it here
             return map.set(this.workerSid, { "userId": this._localDataService.ecd.currentUser.userID, "countryConfigId": this._localDataService.ecd.currentUser.countryConfigurationId, "countryId": this._localDataService.ecd.currentUser.countryId, "workerSid": this.workerSid, "datetime": (this._commonService.getConvertedUTCDate(new Date()).fromDate) + "Z" }, { ttl: this._commonService.convertToSecs(1440)});            
        })
            .then((smap: any) => {
                //Update the user activiey
                if (this._localDataService.ecd.currentUser.isFromLogin) {
                    //Update user activity with 7. this.userStatus[4].activityId
                    this._authenticationService.updateUserActivity(this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), this.userStatus[4].activityId, this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), this._localCookies.get(Constants.APPCOOKIES.CCC_INCIDENTID), 'status').subscribe((res: any) => {
                        this._localDataService.ecd.currentUser.isFromLogin = false;
                    }, (err: any) => {
                        this._localDataService.ecd.currentUser.isFromLogin = true;
                    });
                }
            })
            .catch((error: any) => {
                if (error.code == "20104") {
                    this._commonService.logMessage({ "methodName": "startClientAvailable", "message": "Getting new sync token initiated as previous token got expired. " + (this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) != null ? " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) : ""), "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                    this._authenticationService.getWorkerToken(this.workerSid,this.identity).subscribe((expToken: any) => {
                        this.syncClient = new Client(data?.data?.syncToken);
                        //this.syncClient = new Client(expToken.body.syncToken);

                        this.syncClient.map(Constants.APP_CONFIG.serverBeatKey).then((map: any) => {
                            //get UTC datetime & assign it here
                            return map.set(this.workerSid, { "userId": this._localDataService.ecd.currentUser.userID, "countryConfigId": this._localDataService.ecd.currentUser.countryConfigurationId, "countryId": this._localDataService.ecd.currentUser.countryId, "workerSid": this.workerSid, "datetime": (this._commonService.getConvertedUTCDate(new Date()).fromDate) + "Z" });
                        })
                    })
                }
            });

        // // if (this.syncTimerCount >= 30) {
        // //     this._authenticationService.getWorkerToken(this.workerSid).subscribe((expToken: any) => {
        // //         this.syncClient.updateToken(expToken.body.syncToken);
        // //         this.syncTimerCount = 0;
        // //     });
        // // }
    }
    makeUserAvailableIfOne(reservation: any) {

        //Making the client to not on the call. This will be used in server for process.
        this._localCookies.set(Constants.APPCOOKIES.CCC_ONGOINGCALL, "0");

        //Make user available again, if it's only one user
        this._authenticationService.getStatusFromTwilio({ taskSid: reservation.task.sid, agentName: this.identity, country: reservation.task.attributes.country, language: reservation.task.attributes.language }).subscribe((res: any) => {
            ////console.log('statusid', reservation.task.sid);
            ////console.log('TwilioRespone', res)
            if (!res.body.status) {
                //If code is 2000, then no logged-in Agent is available to take call.
                // So, confirmation pop-up will be shown for logout.               
                //Make agent available
                this.changeStatus("Idle", false);
                //close existing dialog box
                this._dialog.closeAll();
            }
        });
        this.changeStatus("Idle", false);
        let displayElevatorId = (reservation.task.attributes.display_elevator_id=="" || reservation.task.attributes.display_elevator_id== undefined)?reservation.task.attributes.elevator_id:reservation.task.attributes.display_elevator_id;
        //elevator_id,display_unit_number
        ////reservation.task.attributes.display_elevator_id = reservation.task.attributes.elevator_id;
        // // // if (displayElevatorId != null) {
        // // //     if (displayElevatorId.trim().toLowerCase() != 'unknown' && displayElevatorId.trim() != '') {
        // // //         reservation.task.attributes.display_elevator_id = displayElevatorId;
        // // //     }
        // // // }
        if (displayElevatorId != null) {
            if (displayElevatorId.trim().toLowerCase() != 'unknown' && displayElevatorId.trim() != '') {
                reservation.task.attributes.display_elevator_id = displayElevatorId;
            }
        }

        this._pushNotificationService.showNotification({
        unitId: reservation.task.attributes.display_elevator_id,
        body: `${('missedCallMsg')}: ${reservation.task.attributes.display_elevator_id}. ${(('urStatusSetto')).replace('{ string:', ('Offline'))}`,
        isHidden: !this.isWindowActive
        });

        this.callHanged = true;
        window.callHanged = true;
        if (this.syncClient != null) {
            this.updateSyncClient(this._localDataService.ecd.currentUser.userID, this._localDataService.ecd.currentUser.name,
                 "Timeout", this._localDataService.ecd.statusId);
            ////, this._localDataService.ecd.currentUser.callType
        }

        this._localDataService.ecd.statusId = 4;
        this.isTimeout = true;

        clearInterval(this.cancelUserTimeout);
        this.cancelUserTimeout = undefined;
        this.ringtone?.nativeElement?.pause();
        this._commonService.logException({ "methodName": "reservation.timeout", "exceptionDetails": "Reservation Timeout AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
        this._commonService.logMessage({ "methodName": "reservation.timeout", "extraDetails": " Worker name is: " + this._localDataService.ecd.currentUser.name, "message": "", "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });

        //Timeout  
        try{              
        this._authenticationService.updateUserActivity(this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), 4, this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), this._localCookies.get(Constants.APPCOOKIES.CCC_INCIDENTID), 'status', this._localDataService.ecd.currentUser.countryId).subscribe({
                 next: (res: any) => { },
                 error: (err: any) => { 
                     ////console.log('updateUserActivity internal error',err);
                 }
             });
            }
            catch(e)
            {
                this._authenticationService.updateUserActivity(this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), 4, this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID), this._localCookies.get(Constants.APPCOOKIES.CCC_INCIDENTID), 'status', this._localDataService.ecd.currentUser.countryId).subscribe({
                    next: (res: any) => { },
                    error: (err: any) => { 
                        ////console.log('updateUserActivity internal error',err);
                    }
                });
            }

        // if (!this.$$phase) {
        //     this.$digest();
        // }
    }
    /*
        * Method to change user activity & user status.
        * UpdateUserActivtity: will update the user status offline in Twilio.
        * UpdateActivity: will update the activity to CCC database.
    */
    changeStatus(status: any, isFromModel: any, isUserRequest: boolean = false) {
        this.changeStatusConfrmModel = { status: status, isFromModel: isFromModel };

        //waiting activity response from Twilio
        this._commonService.logMessage({ methodName: Constants.PAGE_CONSTANTS.home.changeStatus, 
            userDefined: true, message: Constants.PAGE_CONSTANTS.home.logoutConfirmMsg });
        if (status == 'Offline') { 
            let statusItem = this.userStatus.filter((item: any, i: any) => {
                return item.status === this.changeStatusConfrmModel.status;
              });
              this._localDataService.ecd.statusId = statusItem[0].activityId;
        
              //TODO              
              this.agent.selectedStatus = this.agent.prevSelStatus;            
            this._authenticationService.updateUserActivity(this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), statusItem[0].activityId, null, null, 'status', this._localDataService.ecd.currentUser.countryId).subscribe((res: any) => {
                //$rootScope.loader.showLoader = false;
                if (res.body.status) {                    
                    if (res.body.code == Constants.PAGE_CONSTANTS.home.noAvailableAgent) {
                        //Show confirm to logout.
                        this._commonService.logMessage({ methodName: Constants.PAGE_CONSTANTS.home.logoutConfirm, userDefined: true, message: Constants.PAGE_CONSTANTS.home.logoutConfirmMsg });
                        this.changeStatusConfrmModel = {
                            showMsg: true,
                            display: Constants.APP_CONSTANTS.block,
                            status: status,
                            isFromModel: isFromModel
                        };
                        //incoming call popup disable

                        this.call = {
                            status: false,
                            isTimeout: this.isTimeout
                        };
                        this.incomingCallStatus.next(this.call);
                        //break the execution
                        return;
                    }
                    else {
                        //check if capturing reason for unavailable is enabled
                        if (this._localDataService.ecd.currentUser.enableNotAvailableReason == true) {
                            this.changeStatusConfrmModel = {
                                showMsg: false,
                                display: Constants.APP_CONSTANTS.block,
                                status: status,
                                isFromModel: isFromModel
                            };
                            //incoming call popup disable
                            this.call = {
                                status: false,
                                isTimeout: this.isTimeout
                            };
                            this.incomingCallStatus.next(this.call);
                        } else {
                            this.makeAgentUnavailable(true, false);
                        }
                    }
                }
            });
        }
        else {
            let statusItem = this.userStatus.filter((item: any, i: any) => {
                return item.status === this.changeStatusConfrmModel.status;
              });
              this._localDataService.ecd.statusId = statusItem[0].activityId;
        
              //TODO              
              this.agent.selectedStatus = this.agent.prevSelStatus;        
              //Updating the user status offline in Twilio.
              this._authenticationService.updateUserActivity(this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), statusItem[0].activityId, null, null, 'status', this._localDataService.ecd.currentUser.countryId).subscribe({
                next: (result: any) => {
                  this._commonService.logMessage({ methodName: Constants.PAGE_CONSTANTS.home.changeStatus, userDefined: true, message: Constants.PAGE_CONSTANTS.home.logoutConfirmMsg, extraDetails: "User " + this._localDataService.ecd.currentUser.name + " is changed status" });
                  //TODO                 
                }, error: (err: any) => { }
              });
            this.makeAgentUnavailable(true, false);
        }
    }
    getActivityChanges(callback?: any) {
        this.syncClient.map("UserIdentity" + this._localDataService.ecd?.currentUser?.countryConfigurationId).then((map: any) => {
            map.getItems({pageSize: 100}).then((items: any) => {
                if (callback) {
                    callback(items.items);
                }
                else {
                    this.activityChanges.next(items.items);
                    this.applyWorkerActivityChanges(items.items);
                }
            })
        });
    }
    makeAgentUnavailable(confirm: any, isPopup: any) {
        this.changeStatusConfrmModel.display = Constants.APP_CONSTANTS.none;
        if (confirm) {

            ////this._snackBar.dismiss();
            this._notificationService.hideSnackBar();
            let statusItem = this.userStatus.filter((item: any, i: any) => {
                ////console.log('makeAgentUnavailable status', this.changeStatusConfrmModel.status);
                return item.status === this.changeStatusConfrmModel.status;
            });
            this._localDataService.ecd.statusId = statusItem[0].activityId;
            this.agent.selectedStatus = this.agent.prevSelStatus;
            this.agentStatusEmit.next({
                selectedStatus: this.agent.selectedStatus,
                prevSelStatus: this.agent.prevSelStatus,
                onCallbackStatus: this.agent.onCallbackStatus
            })
            //Updating the activity to CCC database.
            let sid = (this._localCookies.get(Constants.APPCOOKIES.CCC_SID) == null || this._localCookies.get(Constants.APPCOOKIES.CCC_SID) === "") ? this.ccAppSid : this._localCookies.get(Constants.APPCOOKIES.CCC_SID);
            this._authenticationService.updateActivity({ sId: sid, actSId: statusItem[0].sId }).subscribe({
                next: (res: any) => {
                    if (!res.body.status) {
                        this.agent.selectedStatus = this.agent.prevSelStatus;
                        this._notificationService.showSnackBar(res.err);                        
                    }
                    else {
                        this.agent.prevSelStatus = this.agent.selectedStatus;
                    }
                    // If user makes Not Available, and only the Agent is here to attend the call
                    if (isPopup) {
                        if (this._localDataService.ecd.currentUser.callType.indexOf(this.callTypes[1].type) >= 0) {
                            this.syncClient.document('AgentOffline-' + this._localDataService.ecd.currentUser.countryConfigurationId).then((doc: any) => {
                                doc.update({ "event": "Not Available", source: "751" });
                            });
                        }
                    }
                    this.agentStatusEmit.next({
                        selectedStatus: this.agent.selectedStatus,
                        prevSelStatus: this.agent.prevSelStatus,
                        onCallbackStatus: this.agent.onCallbackStatus
                    })
                    this.activityUpdated = true;
                },
                error: (err: any) => {
                    this._commonService.logException(err);
                    ////console.log('update activity error1:', err);
                }

            });
        }
        else {
            this.agent.selectedStatus = "Idle";
            this.agentStatusEmit.next({
                selectedStatus: this.agent.selectedStatus,
                prevSelStatus: this.agent.prevSelStatus,
                onCallbackStatus: this.agent.onCallbackStatus
            })
        }
    }
    // Method to show taskqueue on topbar
    getItemFromMap(isNew?: any) {
        //Get all the item here
        let skills = this._localDataService.ecd.currentUser.languageSkillsId != null ? this._localDataService.ecd.currentUser.languageSkillsId.toLowerCase() : "";
        let state = this._localDataService.ecd.currentUser.callType != null ? this._localDataService.ecd.currentUser.callType.toLowerCase() : "";

        this.syncClient.map(Constants.APP_CONFIG.taskQueueKey + this.queueCountry).then((map: any) => {
            map.getItems().then((result: any) => {
                if (result.items != undefined) {
                    let filteredItems = result.items.filter((itm: any) => {
                        if (itm.descriptor.data.language != null) {
                            return ((state + ",").indexOf(itm.descriptor.data.commissiongState.toLowerCase() + ",") != -1 && itm.descriptor.data.commissiongState !== "");
                        } else {
                            return false;
                        }
                    });
                    let queueCount = 0;
                    if (filteredItems.length > 0) 
                    {   queueCount = 0;
                        filteredItems.forEach((item:any)=>{
                            let dateexpires= new Date(item.descriptor.date_expires);
                            if(item.descriptor.date_expires=="undefined" || item.descriptor.date_expires==undefined)
                            {
                              dateexpires=new Date(item.descriptor.date_updated);
                              dateexpires=new Date(dateexpires.getTime() + 3*60000);
                            }
                            let currentsysdatenow = new Date();       
                            if(currentsysdatenow < dateexpires)
                            {
                             queueCount=queueCount+1;
                            }
                          });
                          this._localCookies.set(Constants.APPCOOKIES.Callcount, queueCount.toString());
                          if (queueCount > 1) {
                            this._notificationService.showSnackBar(queueCount + ' calls are in queue'); 
                            setTimeout(() => {
                                this._notificationService.hideSnackBar();
                            }, 20000);                                                        
                          }
                          else if (queueCount == 1) {
                            this._notificationService.showSnackBar(queueCount + ' call is in queue'); 
                             setTimeout(() => {
                                this._notificationService.hideSnackBar();
                            }, 20000);                           
                          }
                    }
                    else {
                        ////this._snackBar.dismiss();
                        this._notificationService.hideSnackBar();
                        this._localCookies.set(Constants.APPCOOKIES.Callcount, queueCount.toString());
                    }                   
                }
            });
        });
        
    };
    logWSDisconnect(ov: any, nv: any) {
        if (!ov && nv) {// Connected
            if (this.agent.prevSelStatus == "Idle") {
                this.agent.selectedStatus = "Idle";
                this.agentStatusEmit.next({
                    selectedStatus: this.agent.selectedStatus,
                    prevSelStatus: this.agent.prevSelStatus,
                    onCallbackStatus: this.agent.onCallbackStatus
                })
            }
            this._notificationService.hideSnackBar();
            this.twilioWorkerDisconnectedSnackBarRef = null;
            //this.setupAudioCall();            
            AppConfigService.trackEvent("twilio", { name: "logWSDisconnect" }, { "methodName": "websocket.worker.connected", "userDefined": true, "message": "Worker has connected. " + (this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) != null ? " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) : ""), "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
            //this.home.isWebSocketConnected = true;
            //this._commonService.logMessage({ "methodName": "websocket.worker.connected", "userDefined": true, "message": "Worker has connected. " + (this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) != null ? " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) : ""), "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
            
        }

        if (ov && !nv) {// disconnected
            if (this.agent.prevSelStatus == "Idle") {
                this.agent.selectedStatus = "Offline";
                this.agentStatusEmit.next({
                    selectedStatus: this.agent.selectedStatus,
                    prevSelStatus: this.agent.prevSelStatus,
                    onCallbackStatus: this.agent.onCallbackStatus
                })
            }

            if (this._localDataService.ecd.currentUser.roleId != null && (this._localDataService.ecd.currentUser.roleId == '1' || this._localDataService.ecd.currentUser.roleId == '2' || this._localDataService.ecd.currentUser.roleId == '8')) {
                if (!this.twilioWorkerDisconnectedSnackBarRef) {
                this.twilioWorkerDisconnectedSnackBarRef = this._notificationService.showSnackBar(('Your connection to Twilio is disrupted. Please log off and log in again'), "red");
                }
            }
            ////this.home.isWebSocketConnected = false;
            this._dialog.closeAll();
            AppConfigService.trackException("twilio", { exception: new Error(JSON.stringify({ "methodName": "websocket.worker.disconnected", "userDefined": true, "exceptionDetails": "Worker has disconnected. " + (this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) != null ? " AlarmID: " + this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) : ""), "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) })), severityLevel: SeverityLevel.Critical });            
        }
    }
    removeCookies() {
        this.loggedOut = true;
        try {
            if (this._localDataService.ecd.currentUser != null) {
                if (this._localDataService.ecd.currentUser.countryConfigurationId != null) {
                    if (this.syncClient != null) {
                        let userId = this._localCookies.get(Constants.APPCOOKIES.CCC_USERID);
                        this._localDataService.ecd.statusId = 2;
                        this.updateSyncClient(userId, this._localDataService.ecd.currentUser.name, "Offline", this._localDataService.ecd.statusId);
                        ////, this._localDataService.ecd.currentUser.callType
                    }
                }
            }

            //Timeout without time, will executed immediately but after method.
            setTimeout(() => {
                this.clearCallData();
            }, 1000);
        }
        catch (e) { }
    };
    clearCallData() {
        let cookies = this._localCookies.getAll();
        for (let key in cookies) {
            //let value = cookies[key];
            if (key !== Constants.APPCOOKIES.CCC_USER_IDENTITY && key.indexOf(Constants.APPCOOKIES.XSRF) < 0 && key.indexOf(Constants.APPCOOKIES.CSRF) < 0 && key.indexOf(Constants.APPCOOKIES.FILTER_PREFERENCE) < 0 && key.indexOf(Constants.APPCOOKIES.VIDEO_CONTROL_PREFERENCE) < 0 && key.indexOf(Constants.APPCOOKIES.AVAYA_USERID) < 0 && key.indexOf(Constants.APPCOOKIES.AVAYA_EMAILID) < 0 && key.indexOf(Constants.APPCOOKIES.AVAYA_USERNAME) < 0 && key.indexOf(Constants.APPCOOKIES.AVAYA_COUNTRYID) < 0
                && key.indexOf(Constants.APPCOOKIES.AVAYA_LANGUAGEID) < 0 && key.indexOf(Constants.APPCOOKIES.AVAYA_COUNTRY_SHORTNAME) < 0 && key.indexOf(Constants.APPCOOKIES.AVAYA_LANGUAGESTRING) < 0) {
                this._localCookies.delete(key);
            }
        }

         //clear all localstorage data
        //localStorage.clear(); //////////////////////////////////////////////////////////////
        this._localDataService.localstorageRemove('loginData');
        this._localDataService.ecd.currentUserId = undefined;
        this._localDataService.ecd.languageShortName = undefined;
        if (this._localDataService.ecd.appData != undefined) {
        this._localDataService.ecd.appData.workers = {};
        this._localDataService.ecd.appData.workers.identityToken = undefined;
        this._localDataService.ecd.appData.workers.workerToken = undefined;
        this._localDataService.ecd.appData.menuHtml = undefined;
        }

        this.main.selectedItem = 0;
        this._notificationService.hideSnackBar();
        
        if (this.router.url !== "/login") {
            if (this._localDataService.ecd.currentUser) {
                if (this._localDataService.ecd.currentUser.usertype == 'avaya') {
                    this._localDataService.ecd.currentUser = undefined;
                    setTimeout(() => {
                        //TODO::
                        this.router.navigate(['/otislinepbx']);
                    });
                }
                else {
                    this.router.navigate(['/login']);
                    this._localDataService.ecd.currentUser = undefined;
                }
            }
            else {
                this.router.navigate(['/login']);
                this._localDataService.ecd.currentUser = undefined;
            }
        }
    }
    genTokenOnReferesh() {
        if (this.router.url === "/login") {
            return;
        }

        //Pausing the ringtone and navigating to login page if userid cookie is empty
        if (this._localCookies.get(Constants.APPCOOKIES.CCC_USERID) === "" || this._localCookies.get(Constants.APPCOOKIES.CCC_USERID) === undefined && this.router.url != "/join-room" && this.router.url.toLowerCase() != "/otislinepbx") {
            if (this.ringtone) {                
                this.ringtone?.nativeElement?.pause();
            }
            //TODO::
            //This is to make sure, avaya user is always logged in
            if (this.router.url.indexOf("/avaya") === -1) {
                this.router.navigate(['/login']);               
                return;
            }
            else {
                this.router.navigate(['/login']);
                return;
            }
        }
        this._authenticationService.genRefreshToken({ userId: this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), roleId: this._localCookies.get(Constants.APPCOOKIES.CCC_ROLEID) }).subscribe({
            next: (result: any) => {
                if (result?.body?.status) {
                    this._localDataService.ecd.configuration = result?.body?.data.aboutInfo;
                    if (result?.body?.data.isNewLogin)
                        result.body.data.isNewLogin = false;
                    this.userLoginCookiesSet(result?.body?.data);
                }
            },
            error: (err: any) => {
                this._commonService.logException(err);
            }
        });
    }
        /*
    * Broadcast method to redirect to login. This method will be executed, if Agent doesn't have access to API then page will be redirect.
    * This will be called from app.js
    */
    redirectToLogin(status_code: any) {
        if (this._localDataService.ecd.currentUser != undefined) {
        if (this._localDataService.ecd.currentUser.roleId != 3) {
            if (status_code.status == "403" || status_code.status == "401") {
            this.removeCookies();
            }
            else {
            this.logoutWorkerConfirm(true, false);
            }
        }
        else if (this._localDataService.ecd.currentUser.roleId == 3) {
            this.removeCookies();
        }
        else {
            this.logoutAvayaUser();
        }
        }
        else if (this.router.url.indexOf("/avaya") >= 0) {
        this.logoutAvayaUser();
        }
        else {
        this.removeCookies();
        }
    }
    logoutAvayaUser() {
        this._localDataService.ecd.currentUser = undefined;
        this.removeCookies();
        this.router.navigateByUrl('/login');
    }
    invalidateToken() {
        this.admin = false;
        this._localDataService.callAccept = false;
        //TODO:: check below line
        //$rootScope.loader.showLoader = true;
        if (this.validateToken != undefined) {
            clearInterval(this.validateToken);
            this.validateToken = undefined;
        }
    };
    /*
    * Scope method fires after showing logout confirmation to the Agent.
    * If No, just cancel the pop-up and stays there
    * If Yes, call server method to update the database & also Twilio to modify the status.
    */
    logoutWorkerConfirm(confirm: any, isPopup = true, data?: any) {
        if (confirm) {
            //If confirmation is from popup
            if (isPopup) {
                this._commonService.logMessage({ methodName: Constants.PAGE_CONSTANTS.home.logoutConfirm, message: Constants.PAGE_CONSTANTS.home.logoutYesMsg });
            }

            try {
                this.invalidateToken();

                //This will be executed for Agent, Supervisor & Administrator
                if (this._localDataService.ecd.currentUser.isAgent !== 0) {
                    //Updating Activity of the user via Twilio SDK
                    if (this.updateForSaveDisp) {
                        this.updateForSaveDisp(this.userStatus[Constants.PAGE_CONSTANTS.home.status.logoutIndex].sId, (res: any) => {
                            if (res)
                                this.removeCookies();
                        });
                    } else {
                        if (this.agent.selectedStatus == undefined)
                            this.removeCookies();
                    }

                } else {
                    if (this.workerToken == undefined && this._localDataService.ecd.currentUser.isAgent != 0)
                        return;
                    this.removeCookies();
                }
            }
            catch (e) {
                //commonMessage.logException({ methodName: PAGE_CONSTANTS.home.logoutConfirm, message: e.message });
                //  console.log(e)
            }
        }

        this.logoutConfrmModel = { display: Constants.APP_CONSTANTS.none };
        this._notificationService.hideSnackBar();
        ////this._snackBar.dismiss();
    }
    updateForSaveDisp(activitSid: any, callBack?: any) {
        let sid = (this._localCookies.get(Constants.APPCOOKIES.CCC_SID) == null || this._localCookies.get(Constants.APPCOOKIES.CCC_SID) == "") ? this.ccAppSid : this._localCookies.get(Constants.APPCOOKIES.CCC_SID);
        this._notificationService.showSnackBar('call Updating');
        // // this._snackBar.open(("call Updating"), 'Close', {
        // //     panelClass: ['otis-snackbar', 'purple-snackbar'],
        // //     horizontalPosition: 'center',
        // //     verticalPosition: 'top',
        // // });

        let alrmId = this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID);
        this._commonService.logMessage({ "methodName": "worker.activity.update", "extraDetails": " AlarmID: " + alrmId, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "message": "workerUpdationInitiated", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });

        this.worker.activities.forEach((error: any, twilWorker: any) => {
            this._localDataService.ecd.statusId = 7;
            if (error) {
                this._commonService.logException({ "methodName": "worker.activity.update", "exceptionDetails": error + ":" + sid, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                this._authenticationService.updateActivity({ sId: sid, actSId: activitSid }).subscribe({
                    next: (res: any) => {
                        if (res.status) {
                            this._commonService.logMessage({ "methodName": "worker.activity.update", "extraDetails": " AlarmID: " + alrmId, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "message": "workerUpdationSuccess", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                            ////this._snackBar.dismiss();
                            this._notificationService.hideSnackBar();
                            this.checkCallBack(callBack, true);
                        }
                        else {
                            this._commonService.logMessage({ "methodName": "worker.activity.update", "extraDetails": " AlarmID: " + alrmId, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "message": "workerUpdationFailed", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                            this._notificationService.showSnackBar('Activity updation error');
                            // // this._snackBar.open("Activity updation error", 'Close', {
                            // //     panelClass: ['otis-snackbar', 'purple-snackbar'],
                            // //     horizontalPosition: 'center',
                            // //     verticalPosition: 'top',
                            // // });
                            this._commonService.logException({ "methodName": "worker.activity.update", "exceptionDetails": error + ":" + sid, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                            this.checkCallBack(callBack, false);
                        }
                    },
                    error: (err: any) => {
                        this._commonService.logMessage({ "methodName": "worker.activity.update", "extraDetails": " AlarmID: " + alrmId, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "message": "workerUpdationFailed", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        this._commonService.logException(err);
                        this._snackBar.open("Activity updation error", 'Close', {
                            panelClass: ['otis-snackbar', 'purple-snackbar'],
                            horizontalPosition: 'center',
                            verticalPosition: 'top',
                        });
                        this._commonService.logException({ "methodName": "worker.activity.update", "exceptionDetails": err + ":" + sid, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        this.checkCallBack(callBack, false);
                    }
                });
            } else {
                this._commonService.logMessage({ "methodName": "worker.activity.update", "extraDetails": " AlarmID: " + alrmId, "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "message": "workerUpdationSuccess", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                ////this._snackBar.dismiss();
                this._notificationService.hideSnackBar();
                this.agent.selectedStatus = twilWorker.activity.name;
                this.agent.prevSelStatus = twilWorker.activity.name;
                if (twilWorker.activity.name == "Idle") {
                    this.completeAssignedTask();
                }
                //TODO
                // if (!this.$$phase) {
                //     this.$digest();
                // }
                this.checkCallBack(callBack, true);
            }
        });
    }
    checkCallBack(callBack: any, status: any) {
        if (callBack) {
            callBack(status);
        }
    }
    /*
         * Method to logout Twilio worker. Now, this method will fetch available Agent from database.
         * if No Agent present: code: 2000. Showing confirm box.
         * If Agent present: code: 1000. Successfully logged out from system.
         */
    logoutWorker() {
        //This is for Admin, Avaya Agent & for Remote Expert
        // // if (this._localDataService.ecd.currentUser?.isAgent == 0) {
        // //     //If It's normal user like Avaya user. Then No need confirmation. Just logout the user.
        // //     this.logoutWorkerConfirm(true, false);
        // // }
        // // else {
            if(this._localDataService.ecd.currentUser.roleId==3)
            { 
                this.removeCookies()
            }
        
            else if (this._localDataService.ecd.currentUser != undefined) {
                this._authenticationService.updateUserActivity(this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), Constants.PAGE_CONSTANTS.home.activityId, null, null, Constants.PAGE_CONSTANTS.home.logout, this._localDataService.ecd.currentUser.countryId).subscribe((res) => {
                    if (res.body.status) {
                        //This code added by Gopal
                        if (this.syncClient) {
                            this.syncClient.map(Constants.APP_CONFIG.serverBeatKey).then((map: any) => {
                                map.remove(this.workerSid);
                            });
                        } 
                        if (this.updateForSaveDisp) {
                        this.updateForSaveDisp(this.userStatus[Constants.PAGE_CONSTANTS.home.status.logoutIndex].sId, (res: any) => {
                            if (res)
                                this.removeCookies();
                        });
                        }                       
                        if (res.body.code == Constants.PAGE_CONSTANTS.home.noAvailableAgent) {
                            //Show confirm to logout.
                            this._commonService.logMessage({ methodName: Constants.PAGE_CONSTANTS.home.logoutConfirm, userDefined: true, message: Constants.PAGE_CONSTANTS.home.logoutConfirmMsg });

                            this.logoutConfrmModel = {
                                display: Constants.APP_CONSTANTS.block,
                            };
                            //break the execution
                            return;
                        }

                        //If Agent is available, no popup, directly will be logged out
                        /////////this.logoutWorkerConfirm(true, false);
                        ////console.log('logoutWorkerConfirm')
                    }
                });
            } 
            else
                ////console.log('logoutWorkerConfirm1')
                this.logoutWorkerConfirm(true, false);

        
    };
    closeCallForEdit() {
        this.dispositionError = "";
        this.chooseQualityError = "";
        // this.editCallDisp = {
        //     display: 'none'
        // };
    };
    callMakeFalse() {
        this.home.micGain = false;
        this.home.volumeChange = false;
    }
    initiateCallNotificationPopup(attribute: any, self: any, isCallback: any) {
        ////this.elevatorChat = { messages: [] };
        this.isRoomNotDisconnected = true;
        this.incidentDetailsList = [];
        this.homecontroller = { g3msResult: { contractInfo: {}, callDetails: {} } };
        ////this.dataLoadingG3MS = true;
        this.isCallDisconnected = false;
        this.closeCallForEdit();
        this.home.selected = 0;
        
        this.taskAttributes = attribute;
        try {
            //Is Video panel needs to be collapsed
            this.home.isCollapse = false;
            //Is Chat panel needs to be collapsed
            this.home.isChatCollapse = false;
            attribute.alarmId = attribute.alarm_id;
            this.callMakeFalse();
            window.callHanged = false;
            attribute.countryId = this._localDataService.ecd.currentUser.countryId;
            attribute.userId = this._localCookies.get(Constants.APPCOOKIES.CCC_USERID);
            attribute.initiator = this.callInitiator;
            this.callHanged = false;
            this._localDataService.ecd.viewDetails = false;
            ////this.isVVAppCall = true;
            this.agentVideoTransmitEnable = false;
            if (attribute.sipFrom != null) {
                ///this.isVVAppCall = false;
            }
            attribute.elevator_video_enabled = "false"
            if (attribute.agent_video_transmit_enable != null) {
                if (attribute.agent_video_transmit_enable == 'true') {
                    this.agentVideoTransmitEnable = true;
                }
            } else {
                this.agentVideoTransmitEnable = true;
            }
            this.elevatorControls.speakerVolume = this.validateValue(attribute.speaker_volume + "");
            this.elevatorControls.micGain = this.validateValue(attribute.mic_gain + "");
            this.elevatorControls.prevSpeakerVolume = this.elevatorControls.speakerVolume;
            this.elevatorControls.prevMicGain = this.elevatorControls.micGain;
            this.noElevatorVideo = true;
            ////this.video.enabledEle = this.noElevatorVideo;
            ////this.video.enableAgentVideo = true;
            let exp = this._commonService.getCookieExpredDate(1);
            this._localCookies.set(Constants.APPCOOKIES.CCC_ELEVATORID, attribute.elevator_id, { expires: exp });
            this._localCookies.set(Constants.APPCOOKIES.CCC_ALARMID, attribute.alarm_id, { expires: exp });
            this._localCookies.set(Constants.APPCONSTANTS.lastElevatorId, attribute.display_elevator_id, { expires: exp });
            // // this._localCookies.set(Constants.APPCONSTANTS.rem, attribute.remGroupId, { expires: exp });
            this._localDataService.ecd.currentUser.elevatorId = attribute.elevator_id;
            ////attribute.agentVideoTransmitEnable = (this.agentVideoTransmitEnable == true ? 1 : 0);
            this._commonService.logMessage({ "methodName": "callNotificationPopup", "elevatorId": attribute.elevator_id, "message": "insertCallDetails", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
            this._elevatorCallService.insertCallDetails(attribute).subscribe({
                next: (result: any) => {
                    if (result.body.data.recordset.length > 0) {
                        attribute.callIncidentId = result.body.data.recordset[0].callIncidentId;
                        this._localCookies.set(Constants.APPCOOKIES.CCC_INCIDENTID, attribute.callIncidentId, {
                            expires: exp
                        });
                        attribute.callId = result.body.data.recordset[0].callId;
                        this.callDetailsId = result.body.data.recordset[0].callId;
                        if (attribute.elevator_commission_state == null || attribute.elevator_commission_state == "") {
                            attribute.elevator_commission_state = result.body.data.recordset[0].commissioningMode;
                        }
                        //Check the user optout video and pass the message
                        if (!this._localDataService.ecd.currentUser.video || !this.agentVideoTransmitEnable) {
                            ////this.video.enableAgentVideo = false;
                        }
                        //this.incidentDetailsList = result.body.data.recordsets[2];
                        this.homecontroller = { g3msResult: { contractInfo: {}, callDetails: {} } };
                        this.incidentDetailsList = result.body.data.recordsets[2];

                        try {
                            if (this.incidentDetailsList[0].message !== "" && this.incidentDetailsList[0].message != null) {

                                //All the messages, time of sent/ received and sender will be concatenated to one string. Here, it will be split to display.
                                this.incidentDetailsList[0].message = this.incidentDetailsList[0].message.split('+-+');
                            }
                        }
                        catch (e) { }

                        if (isCallback) {
                            //Update the call as accepted
                            this._elevatorCallService.updateCall({
                                incidentId: this._localCookies.get(Constants.APPCOOKIES.CCC_INCIDENTID),
                                alarmId: attribute.alarm_id,
                                ////uniqueId: this._localDataService.ecd.callUniqueId
                            }).subscribe({
                                next: (res: any) => { },
                                error: (err: any) => { }
                            });
                        }

                        //Get G3MS details here
                        let details = " Task SID: " + this.taskSid + ", AlarmID: " + attribute.alarm_id;
                        this._commonService.logMessage({ "methodName": "callNotificationPopup", "extraDetails": details, "elevatorId": attribute.elevator_id, "message": "getElevatorInfo", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                        let payload: any = {};
                        payload.alarm_id = attribute.alarm_id.trim();
                        payload.callerId = attribute.callerId;
                        payload.countryId = attribute.countryId;
                        payload.elevatorId = attribute.elevator_id;
                        payload.remGroupId = attribute.remGroupId;
                        this._elevatorCallService.getElevatorDetails(payload).subscribe({
                            next: (g3msRes: any) => {
                                ////this.dataLoadingG3MS = false;
                                this._commonService.logMessage({ "methodName": "callNotificationPopup", "extraDetails": "", "elevatorId": attribute.elevator_id, "message": "gotResultBack", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                                g3msRes.body.data.contractInfo.commissioningMode = attribute.elevator_commission_state;
                                g3msRes.body.data.contractInfo.failure = attribute.failure;
                                this.homecontroller.g3msResult.contractInfo = g3msRes.body.data.contractInfo;

                                if (this.incidentDetailsList.length > 0) {
                                    this.homecontroller.g3msResult.callDetails = this.incidentDetailsList[0];
                                    this.homecontroller.g3msResult.callDetails.isDBGenerated = attribute.isDBGenerated;
                                }                               

                                this.homecontroller.g3msResult.callDetails.elevatorUnitId = attribute.elevator_id.trim();
                                this._localCookies.set(Constants.APPCOOKIES.CCC_ELEVATORID, attribute.elevator_id.trim());
                                this.homecontroller.g3msResult.callDetails.displayElevatorId = attribute.elevator_id.trim();
                                //Check elevatorId & display ElevatorId are different & also, history of the first call display elevatorId is different from whaterver we got from G3MS response
                                //blow code commented by Gopal                       
                                this.uuid = this.homecontroller.g3msResult.contractInfo.uuid;
                                
                                this.homecontroller.g3msResult.callDetails.fromNumber = g3msRes.body.data.contractInfo.callerId;
                                this.homecontroller.g3msResult.callDetails.remGroupId = g3msRes.body.data.contractInfo.remGroupId;
                                this.homecontroller.g3msResult.contractInfo.note = g3msRes.body.data.contractInfo.unitNotes;
                                this.homecontroller.g3msResult.contractInfo.unitNotes = g3msRes.body.data.contractInfo.unitNotes;
                                this.homecontroller.g3msResult.contractInfo.buildingNotes = g3msRes.body.data.contractInfo.buildingNotes;

                                attribute.controllerType = this.homecontroller.g3msResult.contractInfo.controllerType;
                                attribute.buildingName = this.homecontroller.g3msResult.contractInfo.buildingName;
                                attribute.buildingAddress = this.homecontroller.g3msResult.contractInfo.buildingAddress;
                                attribute.branchName = this.homecontroller.g3msResult.contractInfo.otisBranch;
                                attribute.note = this.homecontroller.g3msResult.contractInfo.note;
                                attribute.buildingNotes = this.homecontroller.g3msResult.contractInfo.buildingNotes;
                                attribute.unitNotes = this.homecontroller.g3msResult.contractInfo.unitNotes;
                                attribute.contractInformation = this.homecontroller.g3msResult.contractInfo.contractInformation;
                                attribute.contractStatus = this.homecontroller.g3msResult.contractInfo.contractStatus;
                                attribute.customerName = this.homecontroller.g3msResult.contractInfo.customerName;
                                attribute.otisBranch = this.homecontroller.g3msResult.contractInfo.otisBranch;
                                attribute.commissioningMode = attribute.elevator_commission_state;
                                this.homecontroller.g3msResult.callDetails.Callstatus = this.homecontroller.g3msResult.contractInfo.Callstatus;
                                attribute.Callstatus = this.homecontroller.g3msResult.contractInfo.Callstatus;
                                attribute.unitState = this.homecontroller.g3msResult.contractInfo.unitState;
                                //this.note=attribute.note;
                                //this.unitNotes=attribute.unitNotes;
                                this.callDetails.next({ g3msResult: this.homecontroller.g3msResult, incidentDetailsList: this.incidentDetailsList, home: this.home, countryConfig: this._localDataService.ecd.countryConfig });
                                this.callInfo.next(this.homecontroller.g3msResult.contractInfo);

                                ////Then insert rest of the details to db
                                this._commonService.logMessage({ "methodName": "callNotificationPopup", "extraDetails": "", "elevatorId": attribute.elevator_id, "message": "savingElevatorDetailsDB", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                                this._elevatorCallService.updateCallDetails(attribute).subscribe({
                                    next: (res: any) => {
                                        this._commonService.logMessage({ "methodName": "callNotificationPopup", "extraDetails": "", "elevatorId": attribute.elevator_id, "message": "savingElevatorDetailsDBSuccess", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                                        this.getWorkerCallActivity({ alarmId: attribute.alarm_id, incidentId: this.incidentDetailsList[0].incidentId });
                                    },
                                    error: (err: any) => {
                                        this._commonService.logMessage({ "methodName": "callNotificationPopup", "extraDetails": "", "elevatorId": attribute.elevator_id, "message": "savingElevatorDetailsDBFailed", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                                    }
                                });

                            }, error: (err: any) => {
                                this._commonService.logMessage({ "methodName": "callNotificationPopup", "extraDetails": "", "elevatorId": attribute.elevator_id, "message": "getElevatorInfoFailed", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                                //this.dataLoadingG3MS = false;
                            }
                        });
                    }
                    else {
                        this._commonService.logMessage({ "methodName": "callNotificationPopup", "elevatorId": attribute.elevator_id, "message": "insertCallDetailsFailed", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });
                    }
                }, 
                error: (err: any) => {
                    this._commonService.logMessage({ "methodName": "callNotificationPopup", "elevatorId": attribute.elevator_id, "message": "insertCallDetailsFailed", "alarmId": this._localCookies.get(Constants.APPCOOKIES.CCC_ALARMID) });

                }
            });
            this.elevatorSettings = {
                videEnabled: attribute.CONFIG_ELEVATORVIDEO_ENABLED
            };
            this.activityUpdated = false;
            attribute.direction = attribute.direction != null ? attribute.direction.toLowerCase() : "--";
            this.call = attribute;
            this.call.isElevatorDisconnected = false;

            this.callTimings = 0;

            if (this.cancelUserTimeout != undefined) {
                clearInterval(this.cancelUserTimeout);
                this.cancelUserTimeout = undefined;
            }

            if (this.validateToken != undefined) {
                clearInterval(this.validateToken);
                this.validateToken = undefined;
            }

            //Above code is moved to below         
            if (self)
                this.incomingCallPopup(attribute);
            else {
                ////this.router.navigateByUrl('/ongoing-elevator-call');
                this.callDetails.next({ g3msResult: this.homecontroller.g3msResult, incidentDetailsList: this.incidentDetailsList, home: this.home, countryConfig: this._localDataService.ecd.countryConfig });
                this.router.navigate(['/ongoing-elevator-call']);   
            }

            this.cancelUserTimeout = setInterval(() => {
                if (this.notifiTimeLeft >= 0) {
                    this.notifiTimeLeft = this.notifiTimeLeft - 1;
                }
                this.callStartedSecs = this.callStartedSecs + 1;
                if (this.callTimings <= 0 && this.callStartedSecs >= 30) {
                    this.isInCallTimeout = true;
                }
                if (this.notifiTimeLeft < 0) {
                    this.notifiTimeLeft = 0;
                    this.isTimeout = true;
                    this.ringtone?.nativeElement?.pause();
                }
                if (this.isInCallTimeout && this._localDataService.ecd.callAccept && this.Reservationerror ===true) {
                    this.isCallDisconnected = 1;                                       
                    this.isInCallTimeout = false;
                    this.callTimings = this.callTimings + 1;
                    alert("Call disconnected from REM, to close the call details page click 'Save & hang up' button");
                }                
            }, 1000);        
            this.callSettings.next({ callStatusDuration: true });
            
        } 
        catch (e) 
        {
            ////console.log('Final erro:', e)
         }
    }
    validateValue(value: any) {
        if (value != null) {
            if (value.trim() === "") {
                return 0;
            }
            else {
                value = value.trim();
                return !isNaN(value) ? value : 0;
            }
        }
        return 0;
    }
    // When the user clicks on <span> (x), close the modal
    // Save and hangup for completing the call    
    updateWorkerToken() {
        let currentsysdatenow = new Date();
        ////console.log('updateWorkerToken occured:',currentsysdatenow);
        this._authenticationService.getWorkerToken(this.workerSid,this.identity).
            subscribe({
                next: (result: any) => {
                    this.worker.updateToken(result.body.workToken);
                     ////console.log('update worker token success',this.workerSid);
                     ////console.log('update worker token',result.body.workToken);
                }, error: (err: any) => {
                    ////console.log('update worker token', err)
                }
            });
    }
    //To show popup if it's RE & not avaya callback
    // // locationChangeStart(event: any) {
    // //     if (this._localCookies.get(Constants.APPCOOKIES.CCC_ONGOINGCALL) != undefined && this._localCookies.get(Constants.APPCOOKIES.CCC_ONGOINGCALL) != "0") {
    // //         this.exitConfirmModel = {
    // //             display: Constants.APP_CONSTANTS.block
    // //         };
    // //         event.preventDefault();
    // //     }
    // // }

    // Error message function. This will be called to parse the response from CIMS.
    
    // // exitConfirm(confirm: any) {
    // //     //To hide exit confirm model
    // //     this.exitConfirmModel = { display: Constants.APP_CONSTANTS.none };

    // //     if (confirm) {
    // //         this.callHanged = true;
    // //         this._localDataService.ecd.callAccept = false;
    // //         this.roomExit();
    // //     }
    // // }
    // // leaveRoomExit(callBack: any) {
    // //     this.leaveRoomIfJoined(callBack, false);
    // // }
    // // roomExit() {
    //     this._localDataService.ecd.callAccept = false;
    //     this._localCookies.set("CCApp-isOngoingCall", "0");
    //     this.leaveRoomExit(
    //         () => {
    //             //commonService.logMessage({ "methodName": "forcedToLogout", "extraDetails": "", "elevatorId": this._localCookies.get(Constants.APPCOOKIES.CCC_ELEVATORID), "message": "forcedToLogout", "alarmId": $cookies.get('CCApp-alarmID') });
    //             this._authenticationService.updateUserActivity(this._localCookies.get(Constants.APPCOOKIES.CCC_USERID), 2, null, null, 'logout', this._localDataService.ecd.currentUser.countryId).subscribe({
    //                 next: (res: any) => { },
    //                 error: (err: any) => { }
    //             });
    //             this.updateForSaveDisp(this.userStatus[3].sId, this.callBack);
    //         }
    //     );
    // };
    
    // this.callNotificationModal.subscribe({
        //     next: (res: boolean) => {
        //         if (res) {
        //             dialogRef.close();
        //             this.callNotificationModal.next(false);
        //         }
        //     }, error() {
        //         console.log('Error');
        //     }, complete() {
        //         console.log('callNotificationModal Finished sequence');
        //     }
        // })
    
    ngOnDestroy() {
    window.removeEventListener('online', () => {});
    }
    errorMsg(res: any) {
        let error = '';//TODO::$scope.translation.unknownErr;
        switch (res.err.statusCode) {
            case 204:
                error = ('invalidElevatorId');//TODO::$scope.menuTranslation.invalidElevatorId;
                break;
            case 400:

                let resMsg = "";
                if (res.data) {
                    resMsg = res.data.messages;
                }
                else {
                    if (res.err) {
                        resMsg = res.err.message;
                    }
                }


                error = ((resMsg == '' || resMsg == "Bad Request") ? ('deviceMayOffline') : (resMsg.indexOf(".") > 0 ? resMsg.slice(0, resMsg.indexOf(".")) : resMsg));
                //TODO::((resMsg == '' || resMsg == "Bad Request") ? $scope.translation.deviceMayOffline: (resMsg.indexOf(".") > 0 ? resMsg.substr(0, resMsg.indexOf(".")) : resMsg));
                break;
            case 401:
                //Unauthorized from CIMS/G3MS
                error = ('unauthorized');//TODO::$scope.translation.unauthorized;
                break;
            case 404:
                //Not found
                error = res.err.message;
                break;
            case 503:
                //Error while process request with SQLServer from CIMS/G3MS
                error = ('sqlUnavailable');//TODO::$scope.translation.sqlUnavailable;
                break;
            case 500:
                //Internal Server error thrown from CIMS/G3MS
                error = ('internalServerError');//TODO::$scope.translation.internalServerError;
                break;
            case 1000:
                //Invalid media region. This will be thrown, when callback, room is tried to created with invalid media region.
                error = ('invalidMediaRegion');//TODO::$scope.translation.invalidMediaRegion;
                break;
            case 1001:
                //Out of service unit
                error = "This unit is not under Otis Service. Unable to call the elevator";
                break;
        }

        return error;
    };    
}
